import React, { useState, useEffect, useMemo, useCallback } from 'react';
import GridLayout from 'react-grid-layout';
import { Row, Col, Label, Input, DatePicker, Button, Stack, PopoverWithContent, Select, Space, Icon, Typography, Spin, ActionList } from 'witmeg-ui-system';
import { useFullScreenHandle, FullScreen } from 'react-full-screen';
import Axios from 'axios';
import moment from 'moment';
import * as _$1 from 'lodash';
import ___default from 'lodash';
import * as XLSX from 'xlsx';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import ReactApexChart from 'react-apexcharts';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var FiltersWidget = function FiltersWidget(props) {
  var id = props.id,
    filters = props.filters,
    handleApplyGlobalFilters = props.handleApplyGlobalFilters,
    handleResetGlobalFilters = props.handleResetGlobalFilters,
    widgetWidth = props.widgetWidth,
    appliedFilters = props.appliedFilters;
  var _useState = useState(filters),
    _useState2 = _slicedToArray(_useState, 2),
    filtersArray = _useState2[0],
    setFiltersArray = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    appliedFilterNames = _useState4[0],
    setAppliedFilterNames = _useState4[1];
  var updateInputValue = function updateInputValue(filterObj, val) {
    console.log("filterObj===>>", filterObj);
    console.log("val ====>>", val);
    var appliedFilters = _toConsumableArray(new Set([].concat(_toConsumableArray(appliedFilterNames), [filterObj.parameterName])));
    setAppliedFilterNames(appliedFilters);
    setFiltersArray(filtersArray.map(function (fo) {
      return {
        id: fo.id,
        parameterName: fo.parameterName,
        parameterType: fo.parameterType,
        dataType: fo.dataType,
        value: fo.id === filterObj.id ? fo.dataType === "number" ? Number(val) : val : fo.value
      };
    }));
  };
  var handleApplyFilters = function handleApplyFilters() {
    console.log("APPLY FILTERS FOR ===>>>>", filtersArray);
    handleApplyGlobalFilters(filtersArray, appliedFilterNames);
  };
  var handleResetFilters = function handleResetFilters() {
    handleResetGlobalFilters();
    setAppliedFilterNames([]);
  };
  var getMinDate = function getMinDate(config) {
    console.log("DATE config ===>>", config);
    if (config) {
      if (config.range === "dynamic") {
        if (config.range === "LastWeek") {
          return moment().utc().subtract(7, 'd');
        } else if (config.value === "Last2Weeks") {
          return moment().utc().subtract(14, 'd');
        } else if (config.value === "LastMonth") {
          return moment().utc().subtract(1, 'months');
        } else if (config.value === "LastQuarter") {
          return moment().utc().subtract(3, 'months');
        } else if (config.value === "Last6Months") {
          return moment().utc().subtract(6, 'months');
        } else if (config.value === "LastYear") {
          return moment().utc().subtract(1, 'years');
        } else {
          return moment('2000-01-01');
        }
      } else {
        return moment(config.value);
      }
    } else {
      return moment('2000-01-01');
    }
  };
  return /*#__PURE__*/React.createElement(Row, {
    className: "eco-mb-24"
  }, filtersArray.map(function (f, i) {
    return /*#__PURE__*/React.createElement(Col, {
      xxl: widgetWidth > 1000 ? 4 : 6,
      xl: widgetWidth > 1000 ? 6 : 8,
      lg: widgetWidth > 1000 ? 6 : 8,
      md: widgetWidth > 1000 ? 8 : 12,
      sm: widgetWidth > 320 ? 12 : 34,
      xs: widgetWidth > 320 ? 12 : 34,
      className: "eco-mb-24",
      key: "".concat(id, "_wdg_").concat(i)
    }, /*#__PURE__*/React.createElement(Row, {
      className: "form-row",
      gutter: [16, 16]
    }, /*#__PURE__*/React.createElement(Col, {
      span: 24
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-lbl-wrapper"
    }, /*#__PURE__*/React.createElement(Label, null, f.parameterName.replace(/([a-z])([A-Z])/g, '$1 $2')))), /*#__PURE__*/React.createElement(Col, {
      span: 24,
      style: {
        textAlign: 'left'
      }
    }, /*#__PURE__*/React.createElement("div", null, function () {
      var _f$config3, _f$config4, _f$config5;
      switch (f.dataType) {
        case "number":
          return /*#__PURE__*/React.createElement(Input, {
            defaultValue: appliedFilters ? f.value : '',
            onKeyPress: function onKeyPress(event) {
              var _f$config, _f$config2;
              var min = (f === null || f === void 0 ? void 0 : (_f$config = f.config) === null || _f$config === void 0 ? void 0 : _f$config.min) || 0;
              var max = (f === null || f === void 0 ? void 0 : (_f$config2 = f.config) === null || _f$config2 === void 0 ? void 0 : _f$config2.max) || 100000;
              console.log("EEEE", event);
              if (!/[0-9]/.test(event.key) && min <= Number(event.target.value) && max >= Number(event.target.value)) {
                event.preventDefault();
              }
            },
            onChange: function onChange(e) {
              updateInputValue(f, e.target.value);
            },
            type: "Number"
            // type={f.dataType === "number" ? 'Number' : 'Text'} 
            ,
            onKe: true,
            className: "filter-input",
            min: (f === null || f === void 0 ? void 0 : (_f$config3 = f.config) === null || _f$config3 === void 0 ? void 0 : _f$config3.min) || 0,
            max: (f === null || f === void 0 ? void 0 : (_f$config4 = f.config) === null || _f$config4 === void 0 ? void 0 : _f$config4.max) || 100000
          });
        case "strArray":
          return /*#__PURE__*/React.createElement(Input, {
            defaultValue: appliedFilters ? f.value : '',
            onChange: function onChange(e) {
              return updateInputValue(f, e.target.value.split(",").filter(function (v) {
                return v !== "";
              }));
            },
            className: "filter-input"
          });
        case "numArray":
          return /*#__PURE__*/React.createElement(Input, {
            defaultValue: appliedFilters ? f.value : '',
            onChange: function onChange(e) {
              return updateInputValue(f, e.target.value.split(",").filter(function (v) {
                return v !== "";
              })).map(function (y) {
                return Number(y);
              });
            },
            className: "filter-input"
          });
        case "date":
          return /*#__PURE__*/React.createElement("div", null, appliedFilters ? /*#__PURE__*/React.createElement(DatePicker, {
            onChange: function onChange(date) {
              return updateInputValue(f, date.utcOffset(0).format("yyyy-MM-DD[T]HH:mm:ss.SSSZ"));
            },
            value: moment(f.value),
            disabledDate: function disabledDate(current) {
              var customDate = moment(); //.utcOffset(0).format("YYYY-MM-DD");
              var minDate = getMinDate(f.config);
              return minDate >= current || customDate <= current;
            }
          }) : /*#__PURE__*/React.createElement(DatePicker, {
            onChange: function onChange(date) {
              return updateInputValue(f, date.utcOffset(0).format("yyyy-MM-DD[T]HH:mm:ss.SSSZ"));
            },
            disabledDate: function disabledDate(current) {
              var customDate = moment(); //.utcOffset(0).format("YYYY-MM-DD");
              var minDate = getMinDate(f.config);
              return minDate >= current || customDate <= current;
            }
          }));
        default:
          return /*#__PURE__*/React.createElement(Input, {
            defaultValue: appliedFilters ? f.value : '',
            onChange: function onChange(e) {
              return updateInputValue(f, e.target.value);
            },
            type: f.dataType === "number" ? 'Number' : 'Text',
            className: "filter-input",
            maxLength: (f === null || f === void 0 ? void 0 : (_f$config5 = f.config) === null || _f$config5 === void 0 ? void 0 : _f$config5.maxLength) || 100
          });
      }
    }()))));
  }), /*#__PURE__*/React.createElement(Col, {
    span: widgetWidth > 700 ? 6 : 24,
    className: "eco-mb-24"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "form-row",
    gutter: [16, 16]
  }, widgetWidth > 700 ? /*#__PURE__*/React.createElement(Col, {
    span: 24
  }, " ", /*#__PURE__*/React.createElement("div", {
    className: "form-lbl-wrapper"
  }, /*#__PURE__*/React.createElement(Label, null, "\xA0"))) : null, /*#__PURE__*/React.createElement(Col, {
    span: 24,
    style: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: handleResetFilters
  }, "Reset"), "\xA0 \xA0", /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: handleApplyFilters
  }, "Apply")))));
};

var isArray = function isArray(obj) {
  return !!obj && obj.constructor === Array;
};
var isObject = function isObject(obj) {
  return _typeof(obj) === 'object' && obj !== null;
};
var returnDataArrayObject = function returnDataArrayObject(resObj) {
  var data = [];
  if (isObject(resObj)) {
    if (isArray(resObj)) {
      // let formattedData  = resObj.map(ro => {})

      return resObj;
    } else {
      var fieldNames = Object.keys(resObj);
      fieldNames.forEach(function (nm) {
        if (isArray(resObj[nm])) {
          data = [].concat(_toConsumableArray(data), _toConsumableArray(resObj[nm]));
          return;
        }
      });
      return data;
    }
  }
};
var chartHelper = function chartHelper(array) {
  var reg = /^\d*\.?\d*$/;
  return {
    dateFormatChange: function dateFormatChange(format) {
      if (!reg.test(array[0]) && _$1.isDate(new Date(array[0])) && moment(array[0]).isValid()) {
        return array.map(function (value) {
          return moment(value).format(format);
        });
      } else if (reg.test(array[0])) {
        return array.map(function (value) {
          return Number(Number(value).toFixed(2));
        });
      }
      return array;
    },
    numberFormat: function numberFormat(decimal) {
      if (reg.test(array[0])) {
        return array.map(function (value) {
          return Number(Number(value).toFixed(decimal));
        });
      }
      return array;
    }
  };
};

var DATE_FORMAT$1 = 'YYYY-MM-DD';

// import { object } from "react-proptypes";

var ChartWidget = function ChartWidget(_ref) {
  var reportData = _ref.reportData,
    resource = _ref.resource,
    reportName = _ref.reportName,
    appliedFilters = _ref.appliedFilters,
    globalFilters = _ref.globalFilters,
    isFullScreenOpen = _ref.isFullScreenOpen;
  var charts = resource.charts,
    availableFields = resource.availableFields,
    dataFilters = resource.dataFilters,
    resourceId = resource.resourceId,
    aggregation = resource.aggregation;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedValues = _useState2[0],
    setSelectedValues = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedFilters = _useState4[0],
    setDataFilters = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    displayData = _useState6[0],
    setDisplayData = _useState6[1];
  var _useState7 = useState(dataFilters),
    _useState8 = _slicedToArray(_useState7, 2),
    currentFilters = _useState8[0],
    setCurrentFilters = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showLegends = _useState10[0],
    setShowLegends = _useState10[1];
  var allSearchOptions = [{
    value: "equal",
    label: "Equal"
  }, {
    value: "gt",
    label: "Greater Than"
  }, {
    value: "lt",
    label: "Less Than"
  }, {
    value: "gte",
    label: "Greater Than Or Equal"
  }, {
    value: "lte",
    label: "Less Than Or Equal"
  }, {
    value: "con",
    label: "Contains"
  }
  // {
  //     value: "between",
  //     label: "Between"
  // },
  ];

  useEffect(function () {
    if (dataFilters && resourceId === charts.resourceId) {
      setDataFilters(dataFilters);
    }
  }, [dataFilters]);
  var groupBy = function groupBy(list, props) {
    var _ref2;
    return (_ref2 = list || []) === null || _ref2 === void 0 ? void 0 : _ref2.reduce(function (a, b) {
      (a[b[props]] = a[b[props]] || []).push(b);
      return a;
    }, {});
  };
  var getTotal = function getTotal(values, fieldName) {
    return Object.keys(values).reduce(function (a, r) {
      a[r] = values[r].reduce(function (acc, val) {
        return acc + Number(val[fieldName]);
      }, 0);
      return a;
    }, {});
  };
  var getValueArray = function getValueArray(values) {
    return Object.keys(values).map(function (val) {
      return {
        name: val,
        value: values[val]
      };
    });
  };
  var filterByDate = function filterByDate(filter, date, format) {
    if (filter.filterType === 'between') {
      return moment(date).isBetween(moment(filter.value1), moment(filter.value2));
    } else if (filter.filterType === 'lte') {
      return moment(moment(date).format(format || DATE_FORMAT$1)).isSameOrBefore(moment(filter.value).format(format || DATE_FORMAT$1));
    } else if (filter.filterType === 'lt') {
      return moment(moment(date).format(format || DATE_FORMAT$1)).isBefore(moment(filter.value).format(format || DATE_FORMAT$1));
    } else if (filter.filterType === 'gte') {
      return moment(moment(date).format(format || DATE_FORMAT$1)).isSameOrAfter(moment(filter.value).format(format || DATE_FORMAT$1));
    } else if (filter.filterType === 'gt') {
      return moment(moment(date).format(format || DATE_FORMAT$1)).isAfter(moment(filter.value).format(format || DATE_FORMAT$1));
    } else {
      return moment(moment(date).format(format || DATE_FORMAT$1)).isSame(moment(filter.value).format(format || DATE_FORMAT$1));
    }
  };
  var filterByNumber = function filterByNumber(filter, value) {
    if (filter.filterType === 'between') {
      return value >= Number(filter.value1) && value <= Number(filter.value2);
    } else if (filter.filterType === 'lte') {
      return value <= Number(filter.value);
    } else if (filter.filterType === 'lt') {
      return value <= Number(filter.value);
    } else if (filter.filterType === 'gte') {
      return value >= Number(filter.value);
    } else if (filter.filterType === 'gt') {
      return value > Number(filter.value);
    } else {
      return value === Number(filter.value);
    }
  };
  var filterByString = function filterByString(filter, value) {
    if (filter.filterType === 'con') {
      return value.toLowerCase().includes(filter.value.toLowerCase());
      //(tc =>)
    } else {
      return value === Number(filter.value);
    }
  };
  var filterValues = function filterValues(field) {
    var results = reportData || [];
    selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.forEach(function (selectedFilter) {
      if (field !== selectedFilter.fieldName) {
        results = results.filter(function (value) {
          if (selectedFilter.dataType === 'date') {
            var _availableFields$find;
            var format = availableFields === null || availableFields === void 0 ? void 0 : (_availableFields$find = availableFields.find(function (f) {
              return (f === null || f === void 0 ? void 0 : f.fieldName) === selectedFilter.fieldName;
            })) === null || _availableFields$find === void 0 ? void 0 : _availableFields$find.format;
            return filterByDate(selectedFilter, value[selectedFilter.fieldName], format);
          }
          if (selectedFilter.dataType === 'number') {
            return filterByNumber(selectedFilter, value[selectedFilter.fieldName]);
          }
          if (selectedFilter.dataType === 'string') {
            return filterByString(selectedFilter, value[selectedFilter.fieldName]);
          }
        });
      }
    });
    return results;
  };
  var formatValues = function formatValues(array, fieldName) {
    var reg = /^\d*\.?\d*$/;
    if (array && Boolean(array.length)) {
      if (!reg.test(array[0][fieldName]) && _$1.isDate(new Date(array[0][fieldName])) && moment(array[0][fieldName]).isValid()) {
        return array.map(function (value) {
          var _availableFields$find2;
          return Object.assign({}, value, _defineProperty({}, fieldName, moment(value[fieldName]).format((availableFields === null || availableFields === void 0 ? void 0 : (_availableFields$find2 = availableFields.find(function (availbleField) {
            return availbleField.fieldName === fieldName;
          })) === null || _availableFields$find2 === void 0 ? void 0 : _availableFields$find2.format) || "YYYY-MM-DD")));
        });
      }
    }
    return array;
  };
  useEffect(function () {
    var _charts$fieldName2, _charts$groupBy;
    // const selectedResults = Boolean(selectedFilters?.length) ? filterValues(charts?.fieldName?.fieldName) : reportData.data;

    var fieldDataFilter = displayData === null || displayData === void 0 ? void 0 : displayData.find(function (filter) {
      var _charts$fieldName;
      return filter.fieldName === (charts === null || charts === void 0 ? void 0 : (_charts$fieldName = charts.fieldName) === null || _charts$fieldName === void 0 ? void 0 : _charts$fieldName.fieldName);
    });
    if (charts !== null && charts !== void 0 && (_charts$fieldName2 = charts.fieldName) !== null && _charts$fieldName2 !== void 0 && _charts$fieldName2.fieldName && charts !== null && charts !== void 0 && (_charts$groupBy = charts.groupBy) !== null && _charts$groupBy !== void 0 && _charts$groupBy.fieldName) {
      var _charts$groupBy2, _charts$groupBy3, _charts$fieldName3, _charts$groupBy4, _charts$groupBy5, _charts$fieldName4;
      selectedFilters !== null && selectedFilters !== void 0 && selectedFilters.length && fieldDataFilter && Boolean(Object.values(fieldDataFilter).length) ? setSelectedValues(getValueArray(getTotal(groupBy(formatValues(displayData, charts === null || charts === void 0 ? void 0 : (_charts$groupBy2 = charts.groupBy) === null || _charts$groupBy2 === void 0 ? void 0 : _charts$groupBy2.fieldName), charts === null || charts === void 0 ? void 0 : (_charts$groupBy3 = charts.groupBy) === null || _charts$groupBy3 === void 0 ? void 0 : _charts$groupBy3.fieldName), charts === null || charts === void 0 ? void 0 : (_charts$fieldName3 = charts.fieldName) === null || _charts$fieldName3 === void 0 ? void 0 : _charts$fieldName3.fieldName)).filter(function (value) {
        return filterByNumber(fieldDataFilter, value.value);
      })) : setSelectedValues(getValueArray(getTotal(groupBy(formatValues(displayData, charts === null || charts === void 0 ? void 0 : (_charts$groupBy4 = charts.groupBy) === null || _charts$groupBy4 === void 0 ? void 0 : _charts$groupBy4.fieldName), charts === null || charts === void 0 ? void 0 : (_charts$groupBy5 = charts.groupBy) === null || _charts$groupBy5 === void 0 ? void 0 : _charts$groupBy5.fieldName), charts === null || charts === void 0 ? void 0 : (_charts$fieldName4 = charts.fieldName) === null || _charts$fieldName4 === void 0 ? void 0 : _charts$fieldName4.fieldName)));
    }
  }, [charts, selectedFilters, displayData]);
  useEffect(function () {
    var _charts$fieldName5;
    var reportDataArr = JSON.parse(JSON.stringify(returnDataArrayObject(reportData))); //displayData.data.map(x => x)
    var selectedResults = Boolean(dataFilters === null || dataFilters === void 0 ? void 0 : dataFilters.length) ? filterValues(charts === null || charts === void 0 ? void 0 : (_charts$fieldName5 = charts.fieldName) === null || _charts$fieldName5 === void 0 ? void 0 : _charts$fieldName5.fieldName) : reportDataArr || reportData;
    if (availableFields && aggregation && aggregation.row && aggregation.row.length > 0) {
      Object.preventExtensions(selectedResults);
      selectedResults.forEach(function (rd, i) {
        aggregation.row.forEach(function (ag, j) {
          if (ag.rowAggregation[0].operator === "add_c") {
            selectedResults[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = Number(rd[ag.rowAggregation[0].fieldName]) + Number(ag.rowAggregation[0].const_1);
          } else if (ag.rowAggregation[0].operator === "multiply_c") {
            selectedResults[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = Number(rd[ag.rowAggregation[0].fieldName]) * Number(ag.rowAggregation[0].const_1);
          } else if (ag.rowAggregation[0].operator === "add") {
            selectedResults[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = Number(rd[ag.rowAggregation[0].fieldName]) + Number(selectedResults[i][ag.rowAggregation[0].field_2]);
          } else if (ag.rowAggregation[0].operator === "multiply") {
            selectedResults[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = Number(rd[ag.rowAggregation[0].fieldName]) * Number(selectedResults[i][ag.rowAggregation[0].field_2]);
          } else if (ag.rowAggregation[0].operator === "sum") {
            selectedResults[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = ag.rowAggregation[0].fieldNamesList.reduce(function (a, b) {
              return a + Number(selectedResults[i][b]);
            }, 0).toFixed(2);
          } else if (ag.rowAggregation[0].operator === "avg") {
            selectedResults[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = (ag.rowAggregation[0].fieldNamesList.reduce(function (a, b) {
              return a + Number(selectedResults[i][b]);
            }, 0) / ag.rowAggregation[0].fieldNamesList.length).toFixed(2);
          } else if (ag.rowAggregation[0].operator === "func") {
            if (ag.rowAggregation[0].calculationStr) {
              var fcn = ag.rowAggregation[0].calculationStr.replaceAll(" ", "").replaceAll("@", "Number(rd['") // {field1} - {field2}        @field1 - @field2
              .replaceAll("$", "'])"); // Number(rd['field1']) - Number(rd['field2'])
              selectedResults[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = Number(eval(fcn)).toFixed(2);
              return;
            }
          }
        });
      });
      setDisplayData(selectedResults);
    } else {
      setDisplayData(selectedResults);
    }
  }, [availableFields, aggregation, dataFilters]);
  var formatDate = function formatDate(array) {
    return chartHelper(array).numberFormat(2);
  };
  var fetchChart = function fetchChart(chartType) {
    var _charts$fieldName6, _charts$groupBy6;
    var options = {
      chart: {
        toolbar: {
          show: false
        },
        height: 640,
        type: chartType ? chartType.toLowerCase() : 'bar',
        zoom: {
          enabled: false
        }
      },
      title: {
        text: charts === null || charts === void 0 ? void 0 : charts.chartName
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'straight'
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'],
          // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      yaxis: {
        title: {
          text: charts === null || charts === void 0 ? void 0 : (_charts$fieldName6 = charts.fieldName) === null || _charts$fieldName6 === void 0 ? void 0 : _charts$fieldName6.fieldName
        }
      },
      xaxis: {
        categories: formatDate(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(function (value) {
          return value.name;
        })),
        title: {
          text: charts === null || charts === void 0 ? void 0 : (_charts$groupBy6 = charts.groupBy) === null || _charts$groupBy6 === void 0 ? void 0 : _charts$groupBy6.fieldName
        }
      }
    };
    return /*#__PURE__*/React.createElement(ReactApexChart, {
      options: options,
      series: [{
        data: formatDate(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(function (value) {
          return value.value;
        }))
      }],
      type: chartType.toLowerCase(),
      height: 350
    });
  };
  var handleSetFilterOption = function handleSetFilterOption(filter, val) {
    var updatedFilters = currentFilters.map(function (c) {
      return Object.assign(c, {
        filterType: filter.id === c.id ? val : c.filterType
      });
    });
    setCurrentFilters(updatedFilters);
  };
  var handleSetFilterValue = function handleSetFilterValue(filter, val) {
    var updatedFilters = currentFilters.map(function (c) {
      return Object.assign(c, {
        value: filter.id === c.id ? val : c.value
      });
    });
    setCurrentFilters(updatedFilters);
  };
  var handleApplyDataFilters = function handleApplyDataFilters() {
    // let filteredData = [...displayData];
    // currentFilters.forEach(cf => {
    //   filteredData=filteredData.filter(fd => fd[cf.fieldName] )
    // })
    // debugger

    var results = _toConsumableArray(displayData) || [];
    currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters.forEach(function (selectedFilter) {
      results = results.filter(function (value) {
        if (selectedFilter.dataType === 'date') {
          var _availableFields$find3;
          var format = availableFields === null || availableFields === void 0 ? void 0 : (_availableFields$find3 = availableFields.find(function (f) {
            return (f === null || f === void 0 ? void 0 : f.fieldName) === selectedFilter.fieldName;
          })) === null || _availableFields$find3 === void 0 ? void 0 : _availableFields$find3.format;
          return filterByDate(selectedFilter, value[selectedFilter.fieldName], format);
        }
        if (selectedFilter.dataType === 'number') {
          return filterByNumber(selectedFilter, value[selectedFilter.fieldName]);
        }
        if (selectedFilter.dataType === 'string') {
          return filterByString(selectedFilter, value[selectedFilter.fieldName]);
        }
      });
    });
    setDisplayData(results);
  };
  var handleResetDataFilters = function handleResetDataFilters() {
    setCurrentFilters(dataFilters.map(function (df) {
      return _objectSpread2(_objectSpread2({}, df), {}, {
        value: ''
      });
    }));
    setDisplayData(reportData);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "report_data_".concat(resource.id)
  }, /*#__PURE__*/React.createElement("div", {
    className: "report-filter-criteria"
  }, /*#__PURE__*/React.createElement("h3", null, "Report Name:", reportName), /*#__PURE__*/React.createElement("h4", null, "Widget Name:", resource.widgetName), appliedFilters ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", null, "Applied Filter Criteria"), globalFilters.map(function (gf) {
    return /*#__PURE__*/React.createElement("p", {
      key: gf.id
    }, /*#__PURE__*/React.createElement("b", null, gf.parameterName, " :"), " \xA0 ", gf.value);
  })) : null), /*#__PURE__*/React.createElement(Stack, {
    horizontalAlign: "h_end"
  }, currentFilters && currentFilters.length > 0 ? /*#__PURE__*/React.createElement(PopoverWithContent, {
    popoverTitle: "Data Filter",
    popoverContent: /*#__PURE__*/React.createElement("div", null, currentFilters.map(function (df, i) {
      return /*#__PURE__*/React.createElement(Row, {
        key: "cdf_".concat(i),
        align: "middle",
        justify: "space-between",
        className: "eco-mb-24",
        gutter: [16, 16]
      }, /*#__PURE__*/React.createElement(Col, {
        span: 8
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-lbl-wrapper"
      }, /*#__PURE__*/React.createElement(Label, null, df.fieldName))), /*#__PURE__*/React.createElement(Col, {
        span: 8
      }, /*#__PURE__*/React.createElement(Select, {
        options: df.dataType === "number" || df.dataType === "date" ? [{
          value: "equal",
          label: "Equal"
        }, {
          value: "gt",
          label: "Greater Than"
        }, {
          value: "lt",
          label: "Less Than"
        }, {
          value: "gte",
          label: "Greater Than Or Equal"
        }, {
          value: "lte",
          label: "Less Than Or Equal"
        }] : [{
          value: "equal",
          label: "Equal"
        }, {
          value: "con",
          label: "Contains"
        }],
        value: allSearchOptions.find(function (aso) {
          return aso.value === df.filterType;
        }),
        onChange: function onChange(e) {
          return handleSetFilterOption(df, e.value);
        }
      })), /*#__PURE__*/React.createElement(Col, {
        span: 8
      }, df.dataType === "number" ? /*#__PURE__*/React.createElement(Input, {
        type: "Number",
        value: df.inputValue,
        onChange: function onChange(e) {
          return handleSetFilterValue(df, Number(e.target.value));
        }
      }) : df.dataType === "date" ? /*#__PURE__*/React.createElement(DatePicker, {
        placeholder: "Date",
        value: moment(df.inputValue),
        onChange: function onChange(date) {
          // console.log("DATE======>>", date)
          handleSetFilterValue(df, date);
        }
      }) : /*#__PURE__*/React.createElement(Input, {
        value: df.inputValue,
        onChange: function onChange(e) {
          return handleSetFilterValue(df, e.target.value);
        }
      })));
    }), /*#__PURE__*/React.createElement(Stack, {
      horizontalAlign: "h_end"
    }, /*#__PURE__*/React.createElement(Space, {
      size: "middle"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: handleResetDataFilters
    }, "Reset"), /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      onClick: handleApplyDataFilters
    }, "Apply"))))
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    name: "filter",
    size: 16
  }))) : null), (charts === null || charts === void 0 ? void 0 : charts.chartType) === 'Pie' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setShowLegends(!showLegends);
    },
    size: "small",
    category: "icon",
    variant: "link",
    children: showLegends ? 'chevron-right' : 'chevron-left'
  })), /*#__PURE__*/React.createElement(ReactApexChart, {
    options: {
      chart: {
        width: 380,
        type: 'pie',
        redrawOnParentResize: true,
        redrawOnWindowResize: true
      },
      title: {
        text: charts === null || charts === void 0 ? void 0 : charts.chartName
      },
      legend: {
        show: showLegends
      },
      labels: formatDate(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(function (value) {
        return value.name;
      })) || [],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
    series: formatDate(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(function (value) {
      return value.value;
    })),
    type: "pie",
    height: isFullScreenOpen ? 600 : 350
  })) : (charts === null || charts === void 0 ? void 0 : charts.chartType) && fetchChart(charts === null || charts === void 0 ? void 0 : charts.chartType));
};

function DataFilters(props) {
  var index = props.index,
    filter = props.filter,
    tableColumn = props.tableColumn,
    onApply = props.onApply,
    onReset = props.onReset;
  var allSearchOptions = [{
    value: "equal",
    label: "Equal"
  }, {
    value: "gt",
    label: "Greater Than"
  }, {
    value: "lt",
    label: "Less Than"
  }, {
    value: "gte",
    label: "Greater Than Or Equal"
  }, {
    value: "lte",
    label: "Less Than Or Equal"
  }, {
    value: "con",
    label: "Contains"
  }
  // {
  //     value: "between",
  //     label: "Between"
  // },
  ];

  var _useState = useState(allSearchOptions.find(function (so) {
      return so.value === filter.filterType;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    inputValue = _useState4[0],
    setInputValue = _useState4[1];
  var _useState5 = useState([{
      value: "equal",
      label: "Equal"
    }, {
      value: "gt",
      label: "Greater Than"
    }, {
      value: "lt",
      label: "Less Than"
    }, {
      value: "gte",
      label: "Greater Than Or Equal"
    }, {
      value: "lte",
      label: "Less Than Or Equal"
    }, {
      value: "con",
      label: "Contains"
    }]),
    _useState6 = _slicedToArray(_useState5, 2),
    searchOptions = _useState6[0],
    setSearchOptions = _useState6[1];
  useEffect(function () {
    if (filter && filter.dataType) {
      console.log("filter=====>>>>>", filter);
      if (filter.dataType === 'number' || filter.dataType === 'date') {
        setSearchOptions([{
          value: "equal",
          label: "Equal"
        }, {
          value: "gt",
          label: "Greater Than"
        }, {
          value: "lt",
          label: "Less Than"
        }, {
          value: "gte",
          label: "Greater Than Or Equal"
        }, {
          value: "lte",
          label: "Less Than Or Equal"
        }]);
      } else {
        setSearchOptions([{
          value: "equal",
          label: "Equal"
        }, {
          value: "con",
          label: "Contains"
        }]);
      }
    }
  }, [filter]);
  var applyDataFilter = function applyDataFilter() {
    console.log("filter, selectedOption.value, inputValue", index, filter, selectedOption.value, inputValue);
    onApply(index, filter, selectedOption.value, inputValue);
  };
  var resetDataFilter = function resetDataFilter() {
    onReset(index, filter);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
    align: "middle",
    justify: selectedOption.value === "between" ? "startspace-between" : 'startspace-between',
    className: "eco-mb-24",
    gutter: [16, 16]
  }, /*#__PURE__*/React.createElement(Col, {
    span: 8
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-lbl-wrapper"
  }, /*#__PURE__*/React.createElement(Label, null, tableColumn.title))), /*#__PURE__*/React.createElement(Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Select, {
    options: searchOptions,
    value: selectedOption,
    onChange: function onChange(e) {
      return setSelectedOption(e);
    }
  })), selectedOption.value === "between" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    span: 8
  }, "\xA0"), /*#__PURE__*/React.createElement(Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Input, null))) : /*#__PURE__*/React.createElement(Col, {
    span: 8
  }, filter.dataType === "number" ? /*#__PURE__*/React.createElement(Input, {
    type: "Number",
    value: inputValue,
    onChange: function onChange(e) {
      return setInputValue(e.target.value);
    }
  }) : filter.dataType === "date" ? /*#__PURE__*/React.createElement(DatePicker, {
    placeholder: "Start Date",
    value: inputValue,
    onChange: function onChange(date) {
      console.log("DATE======>>", date);
      setInputValue(date);
    }
  }) : /*#__PURE__*/React.createElement(Input, {
    value: inputValue,
    onChange: function onChange(e) {
      return setInputValue(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement(Stack, {
    horizontalAlign: "h_end"
  }, /*#__PURE__*/React.createElement(Space, {
    size: "middle"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: resetDataFilter
  }, "Reset"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: applyDataFilter
  }, "Apply"))));
}

var CustomTable = function CustomTable(props) {
  var columns = props.columns,
    dataSource = props.dataSource,
    summaryData = props.summaryData,
    tableID = props.tableID,
    groupConfig = props.groupConfig;
  var memorizedRows = useMemo(function () {
    if (columns) {
      if (dataSource.length > 0) {
        return dataSource.map(function (ds, i) {
          return /*#__PURE__*/React.createElement("tr", {
            key: "tr_".concat(i),
            style: {
              borderBottom: '1px solid #eee'
            }
          }, summaryData && summaryData.length > 0 || groupConfig && groupConfig.advanced && groupConfig.selectedColumns.length > 0 ? /*#__PURE__*/React.createElement("td", {
            className: "summary-data-space"
          }, "\xA0") : null, columns.map(function (dsc, j) {
            return /*#__PURE__*/React.createElement("td", {
              key: "td_".concat(i, "_").concat(j)
            }, dsc.render ? dsc.render(ds[dsc.dataIndex]) : ds[dsc.dataIndex] ? ds[dsc.dataIndex] : '');
          }));
        });
      } else {
        return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
          colspan: "100%"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: '100%',
            textAlign: 'center',
            padding: '24px'
          }
        }, "Data Not Available")));
      }
    }
  }, [dataSource, columns, summaryData]);
  var getMemorizedTotal = function getMemorizedTotal(fieldName) {
    return dataSource.reduce(function (a, b) {
      return a + Number(b[fieldName]);
    }, 0).toFixed(2);
  };
  var matched = function matched(dataArr, a) {
    return dataArr === null || dataArr === void 0 ? void 0 : dataArr.filter(function (b) {
      return a === (b === null || b === void 0 ? void 0 : b.fieldName);
    });
  };
  var onCalculationValue = function onCalculationValue(aggrigationtype, field) {
    if (aggrigationtype === "sum") {
      var _dataSource$reduce;
      return dataSource === null || dataSource === void 0 ? void 0 : (_dataSource$reduce = dataSource.reduce(function (a, curr) {
        return Number(a) + Number(curr[field]);
      }, 0)) === null || _dataSource$reduce === void 0 ? void 0 : _dataSource$reduce.toFixed(2);
    } else if (aggrigationtype === "average") {
      var _ref;
      return (_ref = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.reduce(function (a, curr) {
        return Number(a) + Number(curr[field]);
      }, 0)) / (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length)) === null || _ref === void 0 ? void 0 : _ref.toFixed(2);
    } else if (aggrigationtype === "minimum") {
      return Math.min.apply(Math, _toConsumableArray(dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(function (o) {
        return Number(o[field]);
      })));
    } else if (aggrigationtype === "maximum") {
      return Math.max.apply(Math, _toConsumableArray(dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(function (o) {
        return Number(o[field]);
      })));
    } else if (aggrigationtype === "count") {
      return dataSource === null || dataSource === void 0 ? void 0 : dataSource.length;
    } else if (aggrigationtype === "standarddeviation") {
      return dev(dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(function (o) {
        return Number(o[field]);
      }));
    } else if (aggrigationtype === "variance") {
      return ver(dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(function (o) {
        return Number(o[field]);
      }));
    } else if (aggrigationtype === "median") {
      return median(dataSource === null || dataSource === void 0 ? void 0 : dataSource.map(function (o) {
        return Number(o[field]);
      }));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "widget-table-container"
  }, columns ? /*#__PURE__*/React.createElement("table", {
    className: "widget-table",
    id: "widgetTable".concat(tableID)
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, summaryData && summaryData.length > 0 || groupConfig && groupConfig.advanced && groupConfig.selectedColumns.length > 0 ? /*#__PURE__*/React.createElement("th", {
    className: "summary-data-space custom-table-th"
  }, "\xA0") : null, columns.map(function (c, k) {
    return /*#__PURE__*/React.createElement("th", {
      key: "th_".concat(k),
      className: "custom-table-th"
    }, c.title);
  }))), /*#__PURE__*/React.createElement("tbody", {
    style: {
      borderBottom: '1px solid #aaa',
      borderTop: '1px solid #aaa'
    }
  }, memorizedRows), /*#__PURE__*/React.createElement("tfoot", null, summaryData && summaryData.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, summaryData.map(function (field, index) {
    var _field$displayName;
    return /*#__PURE__*/React.createElement("tr", null, field ? /*#__PURE__*/React.createElement("td", {
      className: "summary-data-space"
    }, " ", /*#__PURE__*/React.createElement("b", null, (_field$displayName = field === null || field === void 0 ? void 0 : field.displayName) !== null && _field$displayName !== void 0 ? _field$displayName : "")) : /*#__PURE__*/React.createElement("td", null), dataSource.length > 0 && Object.keys(dataSource[0]) && (columns === null || columns === void 0 ? void 0 : columns.map(function (a, id) {
      return field ? matched([_objectSpread2({}, field)], a.dataIndex).length ? /*#__PURE__*/React.createElement("td", {
        index: id
      }, /*#__PURE__*/React.createElement("b", null, onCalculationValue(matched([_objectSpread2({}, field)], a.dataIndex)[0].aggType, matched([_objectSpread2({}, field)], a.dataIndex)[0].fieldName))) : /*#__PURE__*/React.createElement("td", {
        index: id
      }) : null;
    })));
  })) : null, /*#__PURE__*/React.createElement("tr", {
    className: "build-talals-row"
  }, groupConfig && groupConfig.advanced && groupConfig.selectedColumns.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
    className: "build-talals-item"
  }, "Grand Total"), dataSource.length > 0 && Object.keys(dataSource[0]) && (columns === null || columns === void 0 ? void 0 : columns.map(function (a, id) {
    return /*#__PURE__*/React.createElement("td", {
      className: "build-talals-item",
      index: id
    }, groupConfig.selectedColumns.findIndex(function (x) {
      return x.fieldName === a.dataIndex;
    }) > -1 ? getMemorizedTotal(a.dataIndex) : '');
  }))) : null))) : null);
};

var img = "data:image/png;base64,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";

// var list = [
//   { name: "1", lastname: "foo1", age: "16" },
//   { name: "2", lastname: "foo", age: "13" },
//   { name: "3", lastname: "foo1", age: "11" },
//   { name: "4", lastname: "foo", age: "11" },
//   { name: "5", lastname: "foo1", age: "16" },
//   { name: "6", lastname: "foo", age: "16" },
//   { name: "7", lastname: "foo1", age: "13" },
//   { name: "8", lastname: "foo1", age: "16" },
//   { name: "9", lastname: "foo", age: "13" },
//   { name: "0", lastname: "foo", age: "16" },
// ];

var groupingByMultipleFields = function groupingByMultipleFields(array, f) {
  var groups = {};
  array.forEach(function (o) {
    var group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
};
var getSumOfGroupByMultiFields = function getSumOfGroupByMultiFields(arr, groupKeys, sumKeys) {
  var hash = Object.create(null),
    grouped = [];
  arr.forEach(function (o) {
    var key = groupKeys.map(function (k) {
      return o[k];
    }).join("|");
    if (!hash[key]) {
      hash[key] = Object.keys(o).reduce(function (result, key) {
        result[key] = o[key];
        if (sumKeys.includes(key)) result[key] = 0;
        return result;
      }, {}); //map_(o) //{ shape: o.shape, color: o.color, used: 0, instances: 0 };
      grouped.push(hash[key]);
    }
    sumKeys.forEach(function (k) {
      if (typeof o[k] === 'number') {
        return hash[key][k] += o[k];
      } else {
        return hash[key][k];
      }
    });
  });
  return grouped;
};

function AdvancedGroupingTable(props) {
  var columns = props.columns,
    dataSource = props.dataSource,
    summaryData = props.summaryData,
    tableID = props.tableID,
    groupConfig = props.groupConfig;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    columsSet = _useState2[0],
    setColumsSet = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    reportData = _useState4[0],
    setReportData = _useState4[1];
  useEffect(function () {
    if (dataSource.length > 0) {
      var uniqueCols = ___default.uniq(dataSource.map(function (x) {
        return x[groupConfig.selectedColumns[0].fieldName];
      })).map(function (col, i) {
        return {
          checked: true,
          key: "gp_c_key_".concat(i),
          dataIndex: col,
          title: col,
          isGroupCol: true,
          dataType: 'number'
        };
      });
      var gTotalCol = [];
      if (groupConfig.selectedColumns.length > 0 && groupConfig.selectedColumns[0].config.showTotals) {
        gTotalCol = [{
          checked: true,
          key: "gp_GT_c_key",
          dataIndex: 'GrandTotal',
          title: 'Grand Total',
          isGroupCol: true,
          dataType: 'number'
        }];
      }
      setColumsSet([].concat(_toConsumableArray(columns.filter(function (x) {
        return groupConfig.selectedRows.findIndex(function (y) {
          return y.fieldName === x.dataIndex;
        }) > -1;
      })), _toConsumableArray(uniqueCols), _toConsumableArray(gTotalCol)));
      var gp = dataSource.map(function (dc) {
        var obj = {};
        uniqueCols.forEach(function (uc) {
          obj[uc.dataIndex] = dc[groupConfig.selectedColumns[0].fieldName] === uc.dataIndex ? dc[groupConfig.selectedValues[0].fieldName] : 0;
        });
        if (groupConfig.selectedColumns.length > 0 && groupConfig.selectedColumns[0].config.showTotals) {
          obj.GrandTotal = uniqueCols.reduce(function (a, b) {
            return a + dc[groupConfig.selectedValues[0].fieldName];
          }, 0);
        }
        return _objectSpread2(_objectSpread2({}, dc), obj);
      });
      var qqq = getGroupedData(gp);
      if (groupConfig.selectedColumns.length > 0 && groupConfig.selectedColumns[0].config.showTotals) {
        setReportData(qqq.map(function (dc) {
          var obj = {};
          obj.GrandTotal = ___default.uniq(dataSource.map(function (x) {
            return x[groupConfig.selectedColumns[0].fieldName];
          })).reduce(function (a, b) {
            return a + dc[b];
          }, 0);
          return _objectSpread2(_objectSpread2({}, dc), obj);
        }));
        //
      } else {
        setReportData(qqq);
      }
    }
  }, [columns, groupConfig, dataSource]);
  var getGroupedData = function getGroupedData(rd) {
    var groupByKeys = groupConfig.fieldNamesList ? groupConfig.fieldNamesList : [];
    var sumKeys = ___default.uniq(dataSource.map(function (x) {
      return x[groupConfig.selectedColumns[0].fieldName];
    }));
    var result = getSumOfGroupByMultiFields(rd, groupByKeys, sumKeys);
    var count = groupingByMultipleFields(rd, function (item) {
      return groupByKeys === null || groupByKeys === void 0 ? void 0 : groupByKeys.map(function (key) {
        return item[key];
      });
    });
    // result = result?.map((obj) =>
    //     Object.fromEntries(
    //         Object.entries(obj)?.filter(
    //             (o) =>
    //                 [...groupByKeys, ...sumKeys]?.includes(o[0]) //||
    //                 // groupConfig?.uniqueFieldNamesList?.includes(o[0])
    //         )
    //     )
    // );
    // let columns = Object.keys(result[0]).map((val, i) => ({
    //     id: i,
    //     fieldName: val,
    //     checked:
    //       resource.availableFields?.find(
    //         (af) => af.fieldName === val
    //       )?.checked ?? true,
    //     dataType: resource.allFields?.find(
    //       (af) => af.fieldName === val
    //     )?.dataType,
    //     grouped: true,
    //   }));

    if ((groupConfig === null || groupConfig === void 0 ? void 0 : groupConfig.operator) === 'sum&count' || (groupConfig === null || groupConfig === void 0 ? void 0 : groupConfig.operator) === 'count') {
      var _count;
      count = (_count = count) === null || _count === void 0 ? void 0 : _count.map(function (c) {
        return c === null || c === void 0 ? void 0 : c.length;
      });

      // columns.push({
      //   id: v4(),
      //   fieldName: "Count",
      //   checked:
      //   resource.availableFields?.find(
      //       (af) => af.fieldName === "Count"
      //     )?.checked ?? true,
      //   dataType: "number",
      //   grouped: true,
      // });

      result = result.map(function (res, i) {
        return Object.assign(res, {
          'Count': count[i]
        });
      });
      return result;
    } else {
      return result;
    }

    //     return {
    //       data: result?.length ? result : [],
    //       fields: columns?.length ? columns : [],
    //     };
    //   } else {
    //     return {
    //       data: result?.length ? result : [],
    //       fields: columns?.length ? columns : [],
    //     };
    //   }
  };

  var memorizedRows = useMemo(function () {
    if (columsSet) {
      if (dataSource.length > 0) {
        return reportData.map(function (ds, i) {
          return /*#__PURE__*/React.createElement("tr", {
            key: "tr_".concat(i),
            style: {
              borderBottom: '1px solid #eee'
            }
          }, summaryData && summaryData.length > 0 || groupConfig && groupConfig.advanced && groupConfig.selectedColumns.length > 0 ? /*#__PURE__*/React.createElement("td", {
            className: "summary-data-space"
          }, "\xA0") : null, columsSet.map(function (dsc, j) {
            return /*#__PURE__*/React.createElement("td", {
              key: "td_".concat(i, "_").concat(j)
            }, dsc.render ? dsc.render(ds[dsc.dataIndex]) : ds[dsc.dataIndex] ? dsc.dataType === 'number' ? Number(ds[dsc.dataIndex]).toFixed(2) : ds[dsc.dataIndex] : '');
          }));
        });
      } else {
        return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
          colspan: "100%"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: '100%',
            textAlign: 'center',
            padding: '24px'
          }
        }, "Data Not Available")));
      }
    }
  }, [reportData, columsSet, summaryData]);
  var getMemorizedTotal = function getMemorizedTotal(fieldName) {
    return reportData.reduce(function (a, b) {
      return a + Number(b[fieldName]);
    }, 0).toFixed(2);
  };
  var matched = function matched(dataArr, a) {
    return dataArr === null || dataArr === void 0 ? void 0 : dataArr.filter(function (b) {
      return a === (b === null || b === void 0 ? void 0 : b.fieldName);
    });
  };
  var onCalculationValue = function onCalculationValue(aggrigationtype, field) {
    if (aggrigationtype === "sum") {
      var _reportData$reduce;
      return reportData === null || reportData === void 0 ? void 0 : (_reportData$reduce = reportData.reduce(function (a, curr) {
        return Number(a) + Number(curr[field]);
      }, 0)) === null || _reportData$reduce === void 0 ? void 0 : _reportData$reduce.toFixed(2);
    } else if (aggrigationtype === "average") {
      var _ref;
      return (_ref = (reportData === null || reportData === void 0 ? void 0 : reportData.reduce(function (a, curr) {
        return Number(a) + Number(curr[field]);
      }, 0)) / (reportData === null || reportData === void 0 ? void 0 : reportData.length)) === null || _ref === void 0 ? void 0 : _ref.toFixed(2);
    } else if (aggrigationtype === "minimum") {
      return Math.min.apply(Math, _toConsumableArray(reportData === null || reportData === void 0 ? void 0 : reportData.map(function (o) {
        return Number(o[field]);
      })));
    } else if (aggrigationtype === "maximum") {
      return Math.max.apply(Math, _toConsumableArray(reportData === null || reportData === void 0 ? void 0 : reportData.map(function (o) {
        return Number(o[field]);
      })));
    } else if (aggrigationtype === "count") {
      return reportData === null || reportData === void 0 ? void 0 : reportData.length;
    } else if (aggrigationtype === "standarddeviation") {
      return dev(reportData === null || reportData === void 0 ? void 0 : reportData.map(function (o) {
        return Number(o[field]);
      }));
    } else if (aggrigationtype === "variance") {
      return ver(reportData === null || reportData === void 0 ? void 0 : reportData.map(function (o) {
        return Number(o[field]);
      }));
    } else if (aggrigationtype === "median") {
      return median(reportData === null || reportData === void 0 ? void 0 : reportData.map(function (o) {
        return Number(o[field]);
      }));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "widget-table-container"
  }, columns ? /*#__PURE__*/React.createElement("table", {
    className: "widget-table",
    id: "widgetTable".concat(tableID)
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, summaryData && summaryData.length > 0 || groupConfig && groupConfig.advanced && groupConfig.selectedColumns.length > 0 ? /*#__PURE__*/React.createElement("th", {
    className: "summary-data-space custom-table-th"
  }, "\xA0") : null, columsSet.map(function (c, k) {
    return /*#__PURE__*/React.createElement("th", {
      key: "th_".concat(k),
      className: "custom-table-th"
    }, c.title);
  }))), /*#__PURE__*/React.createElement("tbody", {
    style: {
      borderBottom: '1px solid #aaa',
      borderTop: '1px solid #aaa'
    }
  }, memorizedRows), /*#__PURE__*/React.createElement("tfoot", null, summaryData && summaryData.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, summaryData.map(function (field, index) {
    var _field$displayName;
    return /*#__PURE__*/React.createElement("tr", null, field ? /*#__PURE__*/React.createElement("td", {
      className: "summary-data-space"
    }, " ", /*#__PURE__*/React.createElement("b", null, (_field$displayName = field === null || field === void 0 ? void 0 : field.displayName) !== null && _field$displayName !== void 0 ? _field$displayName : "")) : /*#__PURE__*/React.createElement("td", null), dataSource.length > 0 && Object.keys(dataSource[0]) && (columns === null || columns === void 0 ? void 0 : columns.map(function (a, id) {
      return field ? matched([_objectSpread2({}, field)], a.dataIndex).length ? /*#__PURE__*/React.createElement("td", {
        index: id
      }, /*#__PURE__*/React.createElement("b", null, onCalculationValue(matched([_objectSpread2({}, field)], a.dataIndex)[0].aggType, matched([_objectSpread2({}, field)], a.dataIndex)[0].fieldName))) : /*#__PURE__*/React.createElement("td", {
        index: id
      }) : null;
    })));
  })) : null, /*#__PURE__*/React.createElement("tr", {
    className: "build-talals-row"
  }, groupConfig && groupConfig.advanced && groupConfig.selectedRows.length > 0 && groupConfig.selectedRows[0].config.showTotals ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
    className: "build-talals-item"
  }, "Grand Total"), reportData.length > 0 && Object.keys(reportData[0]) && (columsSet === null || columsSet === void 0 ? void 0 : columsSet.map(function (a, id) {
    return /*#__PURE__*/React.createElement("td", {
      className: "build-talals-item",
      index: id
    }, ___default.uniq(dataSource.map(function (x) {
      return x[groupConfig.selectedColumns[0].fieldName];
    })).findIndex(function (x) {
      return x === a.dataIndex;
    }) > -1 ? getMemorizedTotal(a.dataIndex) : a.dataIndex === "GrandTotal" ? getMemorizedTotal('GrandTotal') : '');
  }))) : null))) : null);
}

var TableWidget = function TableWidget(_ref) {
  var tableData = _ref.tableData,
    tableColumns = _ref.tableColumns,
    resource = _ref.resource,
    reportName = _ref.reportName,
    appliedFilters = _ref.appliedFilters,
    globalFilters = _ref.globalFilters,
    handleChangeDisplayData = _ref.handleChangeDisplayData,
    appliedDataFilters = _ref.appliedDataFilters,
    organizationName = _ref.organizationName,
    locationName = _ref.locationName,
    userName = _ref.userName,
    curretTime = _ref.curretTime;
  // const { dataFilters } = resource
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    columnSet = _useState2[0],
    setColumnSet = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    filterModal = _useState4[0],
    setFilterModal = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    highlightedColumns = _useState6[0],
    setHighlightedColumns = _useState6[1];
  var _useState7 = useState(tableData),
    _useState8 = _slicedToArray(_useState7, 2),
    displayTableData = _useState8[0],
    setDisplayTableData = _useState8[1];
  // const [filtering, setFiltering] = useState(false);
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    open = _useState10[0],
    setOpen = _useState10[1];
  var _useState11 = useState(appliedDataFilters),
    _useState12 = _slicedToArray(_useState11, 2),
    appliedFilterValues = _useState12[0],
    setAppliedFilterValues = _useState12[1];

  // useEffect(() => {
  //   handleChangeDisplayData({ data: displayTableData, filters: appliedFilterValues})
  //   // setHighlightedColumns(columnSet.filter((x,i) => appliedDataFilters.indexOf(y => y.fieldName===x.dataIndex)).map(z => i))
  // }, [appliedFilterValues, displayTableData])

  useEffect(function () {
    if (displayTableData.length > 0 && appliedDataFilters && appliedDataFilters.length > 0) {
      appliedDataFilters.forEach(function (filter) {
        var selectedOption = filter.selectedOption;
        var inputValue = filter.value;
        if (filter.dataType === "number") {
          if (selectedOption === "gt") {
            // setFiltering(false)
            setDisplayTableData(tableData.filter(function (tc) {
              return Number(tc[filter.fieldName]) > Number(inputValue);
            }));
          } else if (selectedOption === "lt") {
            // setFiltering(false)
            setDisplayTableData(tableData.filter(function (tc) {
              return Number(tc[filter.fieldName]) < Number(inputValue);
            }));
          }
          if (selectedOption === "gte") {
            // setFiltering(false)
            setDisplayTableData(tableData.filter(function (tc) {
              return Number(tc[filter.fieldName]) >= Number(inputValue);
            }));
          } else if (selectedOption === "lte") {
            // setFiltering(false)
            setDisplayTableData(tableData.filter(function (tc) {
              return Number(tc[filter.fieldName]) <= Number(inputValue);
            }));
          } else if (selectedOption === "equal") {
            // setFiltering(false)
            setDisplayTableData(tableData.filter(function (tc) {
              return Number(tc[filter.fieldName]) === Number(inputValue);
            }));
          }
        } else if (filter.dataType === "date") {
          if (selectedOption === "gt") {
            // setFiltering(false)
            setDisplayTableData(tableData.filter(function (tc) {
              return moment(tc[filter.fieldName]) > inputValue;
            }));
          } else if (selectedOption === "lt") {
            // setFiltering(false)
            setDisplayTableData(tableData.filter(function (tc) {
              return moment(tc[filter.fieldName]) < inputValue;
            }));
          }
          if (selectedOption === "gte") {
            // setFiltering(false)
            setDisplayTableData(tableData.filter(function (tc) {
              return moment(tc[filter.fieldName]) >= inputValue;
            }));
          } else if (selectedOption === "lte") {
            // setFiltering(false)
            setDisplayTableData(tableData.filter(function (tc) {
              return moment(tc[filter.fieldName]) <= inputValue;
            }));
          } else if (selectedOption === "equal") {
            // setFiltering(false)
            setDisplayTableData(tableData.filter(function (tc) {
              return moment(tc[filter.fieldName]).format('YYYY-MM-DD') === moment(inputValue).format('YYYY-MM-DD');
            }));
          }
        } else if (filter.dataType === "string") {
          if (selectedOption === "equal") {
            setDisplayTableData(tableData.filter(function (tc) {
              return tc[filter.fieldName] === inputValue;
            }));
          } else {
            setDisplayTableData(tableData.filter(function (tc) {
              return tc[filter.fieldName].toLowerCase().includes(inputValue.toLowerCase());
            }));
          }
        }
      });
    }
  }, [displayTableData, appliedDataFilters]);
  useEffect(function () {
    init();
    function init() {
      return _init.apply(this, arguments);
    }
    function _init() {
      _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var reportData, availableFieldsSet, _resource$aggregation, _resource$aggregation2, _availableFieldsSet, additionalCols;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(resource && resource.aggregation && resource.aggregation.row && resource.aggregation.row.length > 0)) {
                _context3.next = 9;
                break;
              }
              _context3.next = 4;
              return JSON.parse(JSON.stringify(displayTableData));
            case 4:
              reportData = _context3.sent;
              Object.preventExtensions(reportData);
              reportData.forEach(function (cd, i) {
                resource.aggregation.row.forEach(function (ag, j) {
                  switch (ag.rowAggregation[0].operator) {
                    case "add_c":
                      if (ag.rowAggregation[0].fieldName) {
                        reportData[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = Number(Number(cd[ag.rowAggregation[0].fieldName]) + Number(ag.rowAggregation[0].const_1)).toFixed(2);
                        return;
                      }
                      break;
                    case "multiply_c":
                      if (ag.rowAggregation[0].fieldName) {
                        reportData[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = (Number(cd[ag.rowAggregation[0].fieldName]) * Number(ag.rowAggregation[0].const_1)).toFixed(2);
                        return;
                      }
                      break;
                    case "sum":
                      if (ag.rowAggregation[0].fieldNamesList) {
                        reportData[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = Number(ag.rowAggregation[0].fieldNamesList && ag.rowAggregation[0].fieldNamesList.reduce(function (a, b) {
                          return Number(a) + Number(reportData[i][b]);
                        }, 0)).toFixed(2);
                        return;
                      }
                      break;
                    case "avg":
                      if (ag.rowAggregation[0].fieldNamesList) {
                        reportData[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = (ag.rowAggregation[0].fieldNamesList.reduce(function (a, b) {
                          return a + Number(reportData[i][b]);
                        }, 0) / ag.rowAggregation[0].fieldNamesList.length).toFixed(2);
                        return;
                      }
                      break;
                    case "func":
                      if (ag.rowAggregation[0].calculationStr) {
                        var fcn = ag.rowAggregation[0].calculationStr.replaceAll(" ", "").replaceAll("@", "Number(cd['").replaceAll("$", "'])");
                        reportData[i][ag === null || ag === void 0 ? void 0 : ag.displayName] = Number(eval(fcn)).toFixed(2);
                        return;
                      }
                      break;
                    default:
                      return reportData[i];
                  }
                });
              });
              setDisplayTableData(reportData);
              console.log("reportData", reportData);
            case 9:
              if (!(resource && resource.dataFilters && resource.dataFilters.length > 0 && tableColumns)) {
                _context3.next = 16;
                break;
              }
              availableFieldsSet = []; //await JSON.parse(JSON.stringify(tableColumns));
              // Object.preventExtensions(availableFieldsSet);
              if (resource !== null && resource.aggregation && resource.aggregation !== null && resource.aggregation.row && resource.aggregation.row.length > 0) {
                (_resource$aggregation = resource.aggregation) === null || _resource$aggregation === void 0 ? void 0 : (_resource$aggregation2 = _resource$aggregation.row) === null || _resource$aggregation2 === void 0 ? void 0 : _resource$aggregation2.forEach(function (a, k) {
                  availableFieldsSet.push({
                    title: a.displayName,
                    width: 200,
                    dataIndex: a.displayName,
                    key: "col_build_".concat(k),
                    isAggrCol: true,
                    className: "aggr-col",
                    render: function render(text, val) {
                      return a.dataType === "date" ? /*#__PURE__*/React.createElement("div", null, moment(text).utc().format((a === null || a === void 0 ? void 0 : a.format) || DATE_FORMAT)) : (a === null || a === void 0 ? void 0 : a.dataType) === "float" ? /*#__PURE__*/React.createElement("div", null, Number(text).toFixed(a.decimalPoints ? a.decimalPoints : 2)) : _.isNumber(text) ? /*#__PURE__*/React.createElement("div", null, Number(text).toFixed(2)) : /*#__PURE__*/React.createElement("div", null, text);
                    }
                  });
                });
              }
              console.log("availableFieldsSet ===>>", availableFieldsSet);
              setColumnSet([].concat(_toConsumableArray(tableColumns), availableFieldsSet).map(function (tc, i) {
                return {
                  dataIndex: tc.dataIndex,
                  key: tc.key,
                  openPopover: false,
                  render: tc.render,
                  highlighted: tc.highlighted,
                  width: 200,
                  // title: tc.title
                  title: resource.dataFilters.find(function (b) {
                    return b.fieldName === tc.dataIndex;
                  }) ? /*#__PURE__*/React.createElement(Stack, {
                    horizontalAlign: "space_between"
                  }, /*#__PURE__*/React.createElement(Typography, {
                    style: {
                      minWidth: '80px'
                    },
                    pattern: "bold"
                  }, tc.title), /*#__PURE__*/React.createElement(PopoverWithContent, {
                    popoverTitle: "Data Filter",
                    open: filterModal.indexOf(i) > -1,
                    onOpenChange: handleOpenChange,
                    popoverContent: /*#__PURE__*/React.createElement(DataFilters, {
                      index: i,
                      filter: resource.dataFilters.find(function (b) {
                        return b.fieldName === tc.dataIndex;
                      }),
                      tableColumn: tc,
                      onApply: /*#__PURE__*/function () {
                        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(index, addedFilter, selectedOption, inputValue) {
                          var currentFilters;
                          return _regeneratorRuntime().wrap(function _callee$(_context) {
                            while (1) switch (_context.prev = _context.next) {
                              case 0:
                                if (appliedFilterValues) {
                                  currentFilters = appliedFilterValues.filter(function (f) {
                                    return f.fieldName !== addedFilter.fieldName;
                                  });
                                  currentFilters.push(Object.assign(addedFilter, {
                                    value: inputValue,
                                    selectedOption: selectedOption
                                  }));
                                  setAppliedFilterValues(currentFilters);
                                  // console.log("filter", addedFilter)
                                  console.log("displayTableData", displayTableData);
                                  setFilterModal(filterModal.filter(function (x) {
                                    return x !== i;
                                  }));
                                  setOpen(open.filter(function (o) {
                                    return o !== index;
                                  }));
                                  // let filterindData=displayTableData;
                                  // setFiltering(true)
                                  // console.log("tableData.filter(tc => Number(tc[filter.fieldName]) > Number(inputValue))", tableData.filter(tc => Number(tc[filter.fieldName]) > Number(inputValue)))

                                  currentFilters.forEach(function (filter) {
                                    if (filter.dataType === "number") {
                                      if (selectedOption === "gt") {
                                        // setFiltering(false)
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return Number(tc[filter.fieldName]) > Number(inputValue);
                                        }));
                                      } else if (selectedOption === "lt") {
                                        // setFiltering(false)
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return Number(tc[filter.fieldName]) < Number(inputValue);
                                        }));
                                      }
                                      if (selectedOption === "gte") {
                                        // setFiltering(false)
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return Number(tc[filter.fieldName]) >= Number(inputValue);
                                        }));
                                      } else if (selectedOption === "lte") {
                                        // setFiltering(false)
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return Number(tc[filter.fieldName]) <= Number(inputValue);
                                        }));
                                      } else if (selectedOption === "equal") {
                                        // setFiltering(false)
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return Number(tc[filter.fieldName]) === Number(inputValue);
                                        }));
                                      }
                                    } else if (filter.dataType === "date") {
                                      if (selectedOption === "gt") {
                                        // setFiltering(false)
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return moment(tc[filter.fieldName]) > inputValue;
                                        }));
                                      } else if (selectedOption === "lt") {
                                        // setFiltering(false)
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return moment(tc[filter.fieldName]) < inputValue;
                                        }));
                                      }
                                      if (selectedOption === "gte") {
                                        // setFiltering(false)
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return moment(tc[filter.fieldName]) >= inputValue;
                                        }));
                                      } else if (selectedOption === "lte") {
                                        // setFiltering(false)
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return moment(tc[filter.fieldName]) <= inputValue;
                                        }));
                                      } else if (selectedOption === "equal") {
                                        // setFiltering(false)
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return moment(tc[filter.fieldName]).format('YYYY-MM-DD') === moment(inputValue).format('YYYY-MM-DD');
                                        }));
                                      }
                                    } else if (filter.dataType === "string") {
                                      if (selectedOption === "equal") {
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return tc[filter.fieldName] === inputValue;
                                        }));
                                      } else {
                                        setDisplayTableData(tableData.filter(function (tc) {
                                          return tc[filter.fieldName].toLowerCase().includes(inputValue.toLowerCase());
                                        }));
                                      }
                                    }
                                  });
                                  setHighlightedColumns([].concat(_toConsumableArray(highlightedColumns), [index]));
                                  handleChangeDisplayData({
                                    data: tableData,
                                    filters: currentFilters
                                  });
                                }
                              case 1:
                              case "end":
                                return _context.stop();
                            }
                          }, _callee);
                        }));
                        return function (_x, _x2, _x3, _x4) {
                          return _ref2.apply(this, arguments);
                        };
                      }(),
                      onReset: /*#__PURE__*/function () {
                        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(index, filter) {
                          var appliedFilterVals, resetDate;
                          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                            while (1) switch (_context2.prev = _context2.next) {
                              case 0:
                                console.log("filter", filter);
                                appliedFilterVals = appliedFilterValues.filter(function (a) {
                                  return a.fieldName !== filter.fieldName;
                                });
                                setAppliedFilterValues(appliedFilterVals);
                                setOpen(open.filter(function (o) {
                                  return o !== index;
                                }));
                                setFilterModal(filterModal.filter(function (x) {
                                  return x !== i;
                                }));
                                resetDate = tableData;
                                appliedFilterVals.forEach(function (af) {
                                  if (af.dataType === "number") {
                                    if (af.selectedOption === "gt") {
                                      // setFiltering(false)
                                      resetDate = resetDate.filter(function (tc) {
                                        return Number(tc[af.fieldName]) > Number(af.value);
                                      });
                                    } else if (af.selectedOption === "lt") {
                                      // setFiltering(false)
                                      resetDate = resetDate.filter(function (tc) {
                                        return Number(tc[af.fieldName]) < Number(af.value);
                                      });
                                    }
                                    if (af.selectedOption === "gte") {
                                      // setFiltering(false)
                                      resetDate = resetDate.filter(function (tc) {
                                        return Number(tc[af.fieldName]) >= Number(af.value);
                                      });
                                    } else if (af.selectedOption === "lte") {
                                      // setFiltering(false)
                                      resetDate = resetDate.filter(function (tc) {
                                        return Number(tc[af.fieldName]) <= Number(af.value);
                                      });
                                    } else if (af.selectedOption === "equal") {
                                      // setFiltering(false)
                                      resetDate = resetDate.filter(function (tc) {
                                        return Number(tc[af.fieldName]) === Number(af.value);
                                      });
                                    }
                                  } else if (filter.dataType === "date") {
                                    if (af.selectedOption === "gt") {
                                      // setFiltering(false)
                                      resetDate = resetDate.filter(function (tc) {
                                        return moment(tc[af.fieldName]) > af.value;
                                      });
                                    } else if (af.selectedOption === "lt") {
                                      // setFiltering(false)
                                      resetDate = resetDate.filter(function (tc) {
                                        return moment(tc[af.fieldName]) < af.value;
                                      });
                                    }
                                    if (af.selectedOption === "gte") {
                                      // setFiltering(false)
                                      resetDate = resetDate.filter(function (tc) {
                                        return moment(tc[af.fieldName]) >= af.value;
                                      });
                                    } else if (af.selectedOption === "lte") {
                                      // setFiltering(false)
                                      resetDate = resetDate.filter(function (tc) {
                                        return moment(tc[af.fieldName]) <= af.value;
                                      });
                                    } else if (af.selectedOption === "equal") {
                                      // setFiltering(false)
                                      resetDate = resetDate.filter(function (tc) {
                                        return moment(tc[af.fieldName]).format('YYYY-MM-DD') === moment(af.value).format('YYYY-MM-DD');
                                      });
                                    }
                                  } else if (filter.dataType === "string") {
                                    if (af.selectedOption === "equal") {
                                      resetDate = resetDate.filter(function (tc) {
                                        return tc[af.fieldName] === af.value;
                                      });
                                    } else {
                                      resetDate = resetDate.filter(function (tc) {
                                        return tc[af.fieldName].toLowerCase().includes(af.value.toLowerCase());
                                      });
                                    }
                                  }
                                });
                                setDisplayTableData(resetDate);
                                setHighlightedColumns(highlightedColumns.filter(function (h) {
                                  return h !== index;
                                }));
                                handleChangeDisplayData({
                                  data: tableData,
                                  filters: appliedFilterVals
                                });
                                // await handleResetDataFilter(index, filter)
                              case 10:
                              case "end":
                                return _context2.stop();
                            }
                          }, _callee2);
                        }));
                        return function (_x5, _x6) {
                          return _ref3.apply(this, arguments);
                        };
                      }()
                    })
                  }, /*#__PURE__*/React.createElement("div", {
                    onClick: function onClick() {
                      setFilterModal(_toConsumableArray(new Set([].concat(_toConsumableArray(filterModal), [i]))));
                    },
                    style: {
                      width: '20px'
                    }
                  }, /*#__PURE__*/React.createElement(Icon, {
                    name: "filter",
                    size: 16,
                    type: highlightedColumns.indexOf(i) > -1 ? 'filled' : 'outline',
                    color: filterModal === false ? 'blue' : 'blue'
                  })))) : tc.title
                };
              }));
              _context3.next = 21;
              break;
            case 16:
              _context3.next = 18;
              return JSON.parse(JSON.stringify(tableColumns));
            case 18:
              _availableFieldsSet = _context3.sent;
              Object.preventExtensions(_availableFieldsSet);
              if (resource !== null && resource.aggregation && resource.aggregation !== nul && resource.aggregation.row && resource.aggregation.row.length > 0) {
                additionalCols = resource.aggregation.row.map(function (a, k) {
                  return {
                    title: a.displayName,
                    width: 200,
                    dataIndex: a.displayName,
                    key: "col_build".concat(k),
                    isAggrCol: true,
                    className: "aggr-col"
                  };
                });
                setColumnSet([].concat(_toConsumableArray(tableColumns), _toConsumableArray(additionalCols)));
              } else {
                setColumnSet(tableColumns);
              }
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _init.apply(this, arguments);
    }
  }, [resource, tableColumns, highlightedColumns, filterModal]);
  var handleOpenChange = function handleOpenChange(newOpen) {
    console.log("newOpen ====>>", newOpen);
    if (newOpen === false) {
      setFilterModal([]);
    }
    // setFilterModal(newOpen);
  };

  return /*#__PURE__*/React.createElement("div", null, resource ? /*#__PURE__*/React.createElement("div", {
    id: "report_data_".concat(resource.id),
    className: "report-tbl-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "report-tbl-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "report-filter-criteria",
    id: "filter_criteria_".concat(resource.id)
  }, /*#__PURE__*/React.createElement(Row, {
    align: "start"
  }, /*#__PURE__*/React.createElement(Col, {
    span: 18
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: '#245A87',
      fontSize: '18px',
      fontWeight: '400',
      textTransform: 'uppercase'
    }
  }, reportName), /*#__PURE__*/React.createElement("div", {
    style: {
      color: '#245A87',
      fontSize: '24px',
      fontWeight: '700',
      lineHeight: '36px',
      marginBottom: '16px',
      textTransform: 'uppercase'
    }
  }, resource.widgetName), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '24px',
      marginBottom: '24px',
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: '48px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: "bold",
      fontSize: "16px"
    }
  }, "Organization : \xA0"), /*#__PURE__*/React.createElement("span", null, organizationName)), /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: '48px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: "bold",
      fontSize: "16px"
    }
  }, "Location : \xA0"), /*#__PURE__*/React.createElement("span", null, locationName))), appliedFilters ? /*#__PURE__*/React.createElement(Row, {
    gutter: 16,
    style: {
      marginBottom: '36px'
    }
  }, globalFilters.map(function (gf) {
    return /*#__PURE__*/React.createElement(Col, {
      key: gf.id
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, gf.parameterName)), /*#__PURE__*/React.createElement("div", null, gf.dataType === "date" ? moment(gf.value).format('DD/MM/YYYY') : gf.value));
  })) : null), /*#__PURE__*/React.createElement(Col, {
    span: 6
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: img,
    alt: "LOGO",
    style: {
      width: '120px'
    }
  }))))), /*#__PURE__*/React.createElement(React.Fragment, null, resource.aggGroupBuilders && resource.aggGroupBuilders.advanced ? /*#__PURE__*/React.createElement(AdvancedGroupingTable, {
    columns: columnSet,
    dataSource: displayTableData,
    summaryData: resource.aggRowBuilders,
    groupConfig: resource.aggGroupBuilders,
    tableID: resource.id
  }) : /*#__PURE__*/React.createElement(CustomTable, {
    columns: columnSet,
    dataSource: displayTableData,
    summaryData: resource.aggRowBuilders,
    groupConfig: resource.aggGroupBuilders,
    tableID: resource.id
  })), /*#__PURE__*/React.createElement("div", {
    className: "report-footer-data-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "report-footer-data"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "GENERATED BY :\xA0"), /*#__PURE__*/React.createElement("span", null, userName)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Date :\xA0"), /*#__PURE__*/React.createElement("span", null, curretTime.format("MM/DD/YYYY"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Time :\xA0"), /*#__PURE__*/React.createElement("span", null, " ", curretTime.format("HH:mm:ss"))))))) : null);
};

var ReportContainer = function ReportContainer(props) {
  var configDetails = props.configDetails,
    resource = props.resource,
    widgetWidth = props.widgetWidth,
    properties = props.properties,
    userName = props.userName,
    organizationName = props.organizationName,
    locationName = props.locationName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loadingData = _useState4[0],
    setLoadingData = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    columns = _useState6[0],
    setColumns = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showActions = _useState8[0],
    setShowActions = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2);
    _useState10[0];
    var setShowActionMenu = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    var setActionMenuPopoverTriggerEvent = _useState12[1];
  // const [rowData, setRowData] = useState([])
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    dataSource = _useState14[0],
    setDataSource = _useState14[1];
  var _useState15 = useState(resource.customFilters),
    _useState16 = _slicedToArray(_useState15, 2),
    customFilters = _useState16[0],
    setCustomFilters = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    appliedFilters = _useState18[0],
    setAppliedFilters = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showInstructionsMenu = _useState20[0],
    setShowInstructionsMenu = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    tableDisplayData = _useState22[0],
    setTableDisplayData = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    appliedDataFilters = _useState24[0],
    setAppliedDataFilters = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isFullScreenOpen = _useState26[0],
    setIsFullScreenOpen = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2);
    _useState28[0];
    _useState28[1];
  var curretTime = moment().utc();
  var screen = useFullScreenHandle();
  var reportChange = useCallback(function (state, handle) {
    // if (handle === screen) {
    setIsFullScreenOpen(state);
    console.log('Screen 1 went to', state, handle);
    // }
  }, [screen]);
  useEffect(function () {
    if (configDetails && resource && resource.connectionData && resource.connectionData.resoueceType === "Rest API") {
      fetchReportData(resource, null);
      setColumns(resource.availableFields.filter(function (af) {
        return af.checked === true;
      }).map(function (a) {
        return {
          key: "rp_".concat(resource.id, "_col_").concat(a.id),
          title: a.fieldDisplayName ? a.fieldDisplayName : a.fieldName,
          dataIndex: a.fieldName,
          dataType: a.dataType,
          format: a.format,
          decimalPoints: a.decimalPoints,
          highlighted: false,
          checked: a.checked,
          render: function render(text, val) {
            return a.dataType === "date" ? /*#__PURE__*/React.createElement("div", null, moment(text).utc().format((a === null || a === void 0 ? void 0 : a.format) || DATE_FORMAT$1)) : (a === null || a === void 0 ? void 0 : a.dataType) === "float" ? /*#__PURE__*/React.createElement("div", null, Number(text).toFixed(a.decimalPoints ? a.decimalPoints : 2)) : _$1.isNumber(text) ? /*#__PURE__*/React.createElement("div", null, Number(text).toFixed(2)) : getNestedView(text);
          }
        };
      }));
    }
  }, [resource]);
  useEffect(function () {
    if (properties.autorefresh) {
      var timeout = properties.refreshInterval || '30s';

      // const interval = setInterval(() => {
      //     fetchReportData(resource, null)
      // }, 1000*30);
      // return () => clearInterval(interval);
      var addedFilters = appliedFilters ? customFilters : null;
      switch (timeout) {
        case '30s':
          {
            var interval = setInterval(function () {
              fetchReportData(resource, addedFilters);
            }, 1000 * 30);
            return function () {
              return clearInterval(interval);
            };
          }
        case '1m':
          {
            var _interval = setInterval(function () {
              fetchReportData(resource, addedFilters);
            }, 1000 * 60);
            return function () {
              return clearInterval(_interval);
            };
          }
        case '5m':
          {
            var _interval2 = setInterval(function () {
              fetchReportData(resource, addedFilters);
            }, 1000 * 60 * 5);
            return function () {
              return clearInterval(_interval2);
            };
          }
        case '10m':
          {
            var _interval3 = setInterval(function () {
              fetchReportData(resource, addedFilters);
            }, 1000 * 60 * 10);
            return function () {
              return clearInterval(_interval3);
            };
          }
        case '1h':
          {
            var _interval4 = setInterval(function () {
              fetchReportData(resource, addedFilters);
            }, 1000 * 60 * 60);
            return function () {
              return clearInterval(_interval4);
            };
          }
        case '3h':
          {
            var _interval5 = setInterval(function () {
              fetchReportData(resource, addedFilters);
            }, 1000 * 60 * 60 * 30);
            return function () {
              return clearInterval(_interval5);
            };
          }
        // code block
      }
    }
  }, [properties, appliedFilters]);
  var toggleActions = function toggleActions() {
    setShowActions(!showActions);
  };
  var handleShowActions = function handleShowActions(e) {
    console.log('e--------==========', e);
    setActionMenuPopoverTriggerEvent(e);
    setShowActionMenu(true);
    toggleActions();
  };
  var getNestedView = function getNestedView(value) {
    return Array.isArray(value) ? Boolean(value === null || value === void 0 ? void 0 : value.length) ?
    /*#__PURE__*/
    // <Table
    //   columns={getNestedTableColumns(value)}
    //   dataSource={value}
    //   className='report-table'
    //   pagination={false}
    //   checked={false}
    // />
    React.createElement(TableWidget, {
      tableData: value,
      tableColumns: getNestedTableColumns(value),
      resource: null
    }) : "" : /*#__PURE__*/React.createElement("div", null, value);
  };
  var getNestedTableColumns = function getNestedTableColumns(items) {
    if (items && items.length) {
      var _Object$keys, _Object$keys$filter;
      return (_Object$keys = Object.keys(items[0])) === null || _Object$keys === void 0 ? void 0 : (_Object$keys$filter = _Object$keys.filter(function (item) {
        return typeof items[0][item] === "number" || typeof items[0][item] === "string";
      })) === null || _Object$keys$filter === void 0 ? void 0 : _Object$keys$filter.map(function (item) {
        return {
          title: item,
          dataIndex: item,
          key: item,
          render: function render(text) {
            return typeof items[0][item] === "number" ? /*#__PURE__*/React.createElement("div", null, Number(text).toFixed(2)) : {
              text: text
            };
          }
        };
      });
    }
    return "";
  };
  var fetchReportData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resource, globalFilters) {
      var requestValues, authInfo, urlParamSring, i, headerObj, _i, bodyParamObj, _i2, dateCf, dateVal, _dateVal, timestamp, privateKey, payload, signOptions, privateKeyVal;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            console.log("fetchReportData -> resource ->", resource);
            setLoadingData(true);
            requestValues = resource.connectionData.connectionData.requestValues;
            authInfo = resource.connectionData.connectionData.authInfo;
            urlParamSring = "";
            if (requestValues.urlParams.length > 0) {
              urlParamSring = urlParamSring + "?";
              for (i = 0; i < requestValues.urlParams.length; i++) {
                if (requestValues.urlParams[i]["key"] !== "" && requestValues.urlParams[i]["value"] !== "") {
                  urlParamSring = urlParamSring + requestValues.urlParams[i]["key"] + "=" + requestValues.urlParams[i]["value"] + "&";
                }
              }
              urlParamSring.slice(0, -1);
            }
            headerObj = {};
            if (requestValues.requestHeaders.length > 0) {
              for (_i = 0; _i < requestValues.requestHeaders.length; _i++) {
                if (requestValues.requestHeaders[_i]["key"] !== "" && requestValues.requestHeaders[_i]["value"] !== "") {
                  headerObj[requestValues.requestHeaders[_i]["key"]] = requestValues.requestHeaders[_i]["value"];
                }
              }
            }
            bodyParamObj = {}; // if (requestValues.authParams) {
            //     bodyParamObj = Object.assign({}, authParams);
            // }
            if (requestValues.bodyParams.length > 0) {
              for (_i2 = 0; _i2 < requestValues.bodyParams.length; _i2++) {
                if (requestValues.bodyParams[_i2]["key"] !== "" && requestValues.bodyParams[_i2]["value"] !== "") {
                  if (requestValues.bodyParams[_i2]["key"] === "OrgID" || requestValues.bodyParams[_i2]["key"] === "Orgid" || requestValues.bodyParams[_i2]["key"] === "OrganizationID") {
                    bodyParamObj[requestValues.bodyParams[_i2]["key"]] = props.organizationId;
                  } else if (requestValues.bodyParams[_i2]["key"] === "CloudLocationID") {
                    bodyParamObj[requestValues.bodyParams[_i2]["key"]] = props.cloudLocationId;
                  } else {
                    bodyParamObj[requestValues.bodyParams[_i2]["key"]] = requestValues.bodyParams[_i2]["value"];
                  }
                }
                if (requestValues.bodyParams[_i2]["key"] !== "" && requestValues.bodyParams[_i2]["dataType"] === "date") {
                  if (requestValues.bodyParams[_i2]["dateConfig"]) {
                    dateCf = requestValues.bodyParams[_i2]["dateConfig"];
                    if (dateCf.dateOption === "daysBefore") {
                      dateVal = moment.utc().subtract(dateCf.timeUnits, 'day').startOf('day').format(dateCf.dateFormat);
                      bodyParamObj[requestValues.bodyParams[_i2]["key"]] = dateVal;
                    } else if (dateCf.dateOption === "today") {
                      _dateVal = moment().format(dateCf.dateFormat);
                      bodyParamObj[requestValues.bodyParams[_i2]["key"]] = _dateVal;
                    }
                  }
                }
              }
            }
            if (globalFilters && globalFilters.length > 0) {
              globalFilters.forEach(function (element) {
                if (element.parameterName !== "") {
                  if (element.parameterType === "query") {
                    if (urlParamSring === "") {
                      urlParamSring = urlParamSring + "?";
                    }
                    urlParamSring = urlParamSring + element.parameterName + "=" + element.value + "&";
                  } else {
                    bodyParamObj[element.parameterName] = element.value;
                  }
                }
              });
            }
            if (!(authInfo.method === "jwt")) {
              _context2.next = 27;
              break;
            }
            timestamp = (new Date().getTime() + 1000 * 60 * 60 * 24 * 7) / 1000;
            privateKey = authInfo.parameters.privateKey;
            payload = {
              aud: authInfo.parameters.aud,
              exp: timestamp,
              iss: authInfo.parameters.iss,
              usertoken: props.token
            };
            signOptions = {
              algorithm: "RS256"
            };
            privateKeyVal = privateKey ? privateKey.replace(/\\n/g, "\n") : null;
            if (!privateKeyVal) {
              _context2.next = 25;
              break;
            }
            _context2.prev = 18;
            _context2.next = 21;
            return Axios({
              method: 'post',
              url: 'https://api-report.throbox.com/generate-jwt-token',
              // url: 'http://localhost:8080/generate-jwt-token',
              data: JSON.parse(JSON.stringify({
                payload: payload,
                privateKeyVal: privateKeyVal,
                signOptions: signOptions
              })),
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json"
              }
            }).then( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resp) {
                var token, httpConfig;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      token = resp.data.token; // setApiTestStatus("success")
                      httpConfig = null;
                      if (!(requestValues.bodyParams.length > 0 && resource.connectionData.connectionData.requestValues.httpMethod === "post")) {
                        _context.next = 6;
                        break;
                      }
                      httpConfig = {
                        method: "post",
                        // url: resource.connectionData.connectionData.baseUrl + urlParamSring,
                        headers: {
                          "Access-Control-Allow-Origin": "*",
                          "Content-Type": "application/json",
                          Authorization: "Bearer " + token
                        },
                        body: JSON.stringify(bodyParamObj)
                      };
                      _context.next = 6;
                      return fetch(resource.connectionData.connectionData.baseUrl + urlParamSring, httpConfig).then(function (data) {
                        return data.json();
                      }).then(function (response) {
                        console.log("resource XXXX ===>>", resource);
                        if (resource.aggGroupBuilders && !_$1.isEmpty(resource.aggGroupBuilders) && resource.aggGroupBuilders.advanced) {
                          var data = returnDataArrayObject(response.Result);
                          // console.log("data==>>>", data)
                          // setRowData(returnDataArrayObject(data))
                          setDataSource(returnDataArrayObject(data));
                          setTableDisplayData(returnDataArrayObject(data));
                          // setAppliedDataFilters([])
                          setLoadingData(false);
                        }
                        if (resource.aggGroupBuilders && !_$1.isEmpty(resource.aggGroupBuilders)) {
                          var _data = getGroupedData(returnDataArrayObject(response.Result));
                          // console.log("data==>>>", data)
                          // setRowData(returnDataArrayObject(data))
                          setDataSource(returnDataArrayObject(_data));
                          setTableDisplayData(returnDataArrayObject(_data));
                          // setAppliedDataFilters([])
                          setLoadingData(false);
                        } else {
                          // setRowData(returnDataArrayObject(response))
                          setDataSource(returnDataArrayObject(response));
                          setTableDisplayData(returnDataArrayObject(response));
                          // setAppliedDataFilters([])
                          setLoadingData(false);
                          // let reportData = response.Result;
                        }
                        // Object.preventExtensions(reportData);
                        // if (response) {
                        //     setLoading(false)
                        //     layoutData[idx].reportData = {
                        //         rawData: response
                        //             ? returnDataArrayObject(response)
                        //             : null,
                        //         displayData: response
                        //             ? returnDataArrayObject(response)
                        //             : null,
                        //         fieldsToShow: resource.availableFields
                        //             ? resource.availableFields
                        //             : null,
                        //         availableFields: resource.availableFields
                        //             ? resource.availableFields
                        //             : null,
                        //         aggregation: resource.aggregation
                        //             ? resource.aggregation
                        //             : null,
                        //         aggRowBuilders: resource.aggRowBuilders
                        //             ? resource.aggRowBuilders
                        //             : null,
                        //         aggGroupBuilders: resource.aggGroupBuilders
                        //             ? resource.aggGroupBuilders
                        //             : null,
                        //         groupedReportData: resource.groupedReportData && Boolean(resource.groupedReportData.length)
                        //             ? resource.groupedReportData
                        //             : null,
                        //         widgetName: resource.widgetName
                        //             ? resource.widgetName
                        //             : resource.connectionData &&
                        //                 resource.connectionData.name
                        //                 ? resource.connectionData.name
                        //                 : "",
                        //         connectionData: resource.connectionData,
                        //         customFilters: resource.customFilters && resource.customFilters.length > 0
                        //             ? resource.customFilters
                        //             : null,
                        //         dataFilters: resource.dataFilters && resource.dataFilters.length > 0
                        //             ? resource.dataFilters
                        //             : null
                        //     };
                        //     setFieldToShow([
                        //         ...fieldsToShow,
                        //         resource.availableFields,
                        //     ]);
                        //     setLayoutData(() => layoutData);
                        // }
                      })["catch"](function (error) {
                        setLoading(false);
                        // setReportDataStatus("error")
                        // setReportDataObject(null)
                        // console.log(error);
                      });
                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }());
          case 21:
            _context2.next = 25;
            break;
          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](18);
          case 25:
            _context2.next = 30;
            break;
          case 27:
            ({
              method: resource.connectionData.connectionData.requestValues.httpMethod,
              // url: resource.connectionData.connectionData.baseUrl + urlParamSring,
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json"
              }
              // body: JSON.stringify(bodyParamObj),
            });
            _context2.next = 30;
            return fetch(resource.connectionData.connectionData.baseUrl + urlParamSring
            // httpConfig
            ).then(function (data) {
              return data.json();
            }).then(function (response) {
              if (resource.aggGroupBuilders) {
                // const data = getGroupedData(returnDataArrayObject(response));
                // console.log("data==>>>", data)
                // setRowData(returnDataArrayObject(data))
                // setDataSource(returnDataArrayObject(data))
                setLoadingData(false);
              } else {
                // setRowData(returnDataArrayObject([
                //     {
                //       "userId": 1,
                //       "id": 1,
                //       "title": "quidem molestiae enim"
                //     },
                //     {
                //       "userId": 1,
                //       "id": 2,
                //       "title": "sunt qui excepturi placeat culpa"
                //     },
                //     {
                //       "userId": 1,
                //       "id": 3,
                //       "title": "omnis laborum odio"
                //     }]))
                setDataSource(returnDataArrayObject(response));
                setTableDisplayData(returnDataArrayObject(response));
                // setAppliedDataFilters([])
                setLoadingData(false);
                // let reportData = response.Result;
              }
            })["catch"](function (error) {
              setLoadingData(false);
              // setReportDataStatus("error")
              // setReportDataObject(null)
              console.log("error", error);
            });
          case 30:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[18, 23]]);
    }));
    return function fetchReportData(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var getGroupedData = function getGroupedData(reportData) {
    var _result, _resource$aggGroupBui5, _resource$aggGroupBui6;
    var groupByKeys = resource.aggGroupBuilders.fieldNamesList ? resource.aggGroupBuilders.fieldNamesList : [];
    var sumKeys = resource.aggGroupBuilders.sumFieldNamesList ? resource.aggGroupBuilders.sumFieldNamesList : [];
    var result = getSumOfGroupByMultiFields(reportData, groupByKeys, sumKeys);
    var count = groupingByMultipleFields(reportData, function (item) {
      return groupByKeys === null || groupByKeys === void 0 ? void 0 : groupByKeys.map(function (key) {
        return item[key];
      });
    });
    result = (_result = result) === null || _result === void 0 ? void 0 : _result.map(function (obj) {
      var _Object$entries;
      return Object.fromEntries((_Object$entries = Object.entries(obj)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.filter(function (o) {
        var _resource$aggGroupBui, _resource$aggGroupBui2, _resource$aggGroupBui3, _resource$aggGroupBui4;
        return ((_resource$aggGroupBui = resource.aggGroupBuilders) === null || _resource$aggGroupBui === void 0 ? void 0 : (_resource$aggGroupBui2 = _resource$aggGroupBui.displayFieldNamesList) === null || _resource$aggGroupBui2 === void 0 ? void 0 : _resource$aggGroupBui2.includes(o[0])) || ((_resource$aggGroupBui3 = resource.aggGroupBuilders) === null || _resource$aggGroupBui3 === void 0 ? void 0 : (_resource$aggGroupBui4 = _resource$aggGroupBui3.uniqueFieldNamesList) === null || _resource$aggGroupBui4 === void 0 ? void 0 : _resource$aggGroupBui4.includes(o[0]));
      }));
    });
    // let columns = Object.keys(result[0]).map((val, i) => ({
    //     id: i,
    //     fieldName: val,
    //     checked:
    //       resource.availableFields?.find(
    //         (af) => af.fieldName === val
    //       )?.checked ?? true,
    //     dataType: resource.allFields?.find(
    //       (af) => af.fieldName === val
    //     )?.dataType,
    //     grouped: true,
    //   }));

    if (((_resource$aggGroupBui5 = resource.aggGroupBuilders) === null || _resource$aggGroupBui5 === void 0 ? void 0 : _resource$aggGroupBui5.operator) === 'sum&count' || ((_resource$aggGroupBui6 = resource.aggGroupBuilders) === null || _resource$aggGroupBui6 === void 0 ? void 0 : _resource$aggGroupBui6.operator) === 'count') {
      var _count;
      count = (_count = count) === null || _count === void 0 ? void 0 : _count.map(function (c) {
        return c === null || c === void 0 ? void 0 : c.length;
      });

      // columns.push({
      //   id: v4(),
      //   fieldName: "Count",
      //   checked:
      //   resource.availableFields?.find(
      //       (af) => af.fieldName === "Count"
      //     )?.checked ?? true,
      //   dataType: "number",
      //   grouped: true,
      // });

      result = result.map(function (res, i) {
        return Object.assign(res, {
          'Count': count[i]
        });
      });
      return result;
    } else {
      return result;
    }

    //     return {
    //       data: result?.length ? result : [],
    //       fields: columns?.length ? columns : [],
    //     };
    //   } else {
    //     return {
    //       data: result?.length ? result : [],
    //       fields: columns?.length ? columns : [],
    //     };
    //   }
  };

  var handleApplyGlobalFilters = function handleApplyGlobalFilters(globalFiltersArr, appliedFilterNames) {
    console.log("globalFilters ===>>", globalFiltersArr);
    console.log("appliedFilterNames ===>>", appliedFilterNames);
    setAppliedFilters(true);
    setCustomFilters(globalFiltersArr.filter(function (fou) {
      return appliedFilterNames.indexOf(fou.parameterName) > -1;
    }));
    fetchReportData(resource, globalFiltersArr);
  };
  var handleResetGlobalFilters = function handleResetGlobalFilters() {
    setAppliedFilters(false);
    setCustomFilters(resource.customFilters);
    fetchReportData(resource, []);
  };
  // const [columns, setColumns] = useState([
  //     {
  //         title: <Stack horizontalAlign="space_between">
  //             <Typography>Name</Typography>
  //             <PopoverWithContent
  //                 popoverTitle="Data Filter"
  //                 popoverContent={
  //                     <div>
  //                         <Row align="middle" justify="space-between" className="eco-mb-24" gutter={[16, 16]}>
  //                             <Col span={8}>
  //                                 <div className='form-lbl-wrapper'><Label>Sales Date</Label></div>
  //                             </Col>
  //                             <Col span={8}>
  //                                 <Select options={searchOptions} />
  //                             </Col>
  //                             <Col span={8}>
  //                                 <DatePicker placeholder="Start Date" />
  //                             </Col>
  //                         </Row>
  //                         <Stack horizontalAlign="h_end">
  //                             <Space size="middle">
  //                                 <Button variant="secondary">Reset</Button>
  //                                 <Button variant="primary">Apply</Button>
  //                             </Space>
  //                         </Stack>

  //                     </div>
  //                 }>
  //                 <div onClick={() => setFilterModal(!filterModal)}><Icon name="filter" size={16} color={filterModal === false ? 'blue' : 'gray'} /></div>
  //             </PopoverWithContent>
  //         </Stack>,
  //         dataIndex: "name",
  //         key: "name",
  //     },
  //     {
  //         title: "Age",
  //         dataIndex: "age",
  //         key: "age",
  //     },
  //     {
  //         title: "Address",
  //         dataIndex: "address",
  //         key: "address",
  //     },
  // ]);

  // const [dataSource, setDataSource] = useState([
  //     {
  //         key: "1",
  //         name: "Mike",
  //         age: 32,
  //         address: "10 Downing Street",
  //     },
  //     {
  //         key: "2",
  //         name: "John",
  //         age: 42,
  //         address: "10 Downing Street",
  //     },
  //     {
  //         key: "3",
  //         name: "cena",
  //         age: 42,
  //         address: "10 Downing Street",
  //     },
  //     {
  //         key: "4",
  //         name: "Randy",
  //         age: 42,
  //         address: "10 Downing Street",
  //     },
  // ]);

  var downloadReportData = function downloadReportData() {
    // let downloadData = tableDisplayData.map(d => { 
    //     let obj={}; 
    //     columns.forEach(x => {
    //         if(x.dataType==='date') {
    //             obj[x.dataIndex] = moment(d[x.dataIndex]).format('YYYY-MM-DD')
    //         } else {
    //             obj[x.dataIndex] = d[x.dataIndex]
    //         }
    //     }); 
    //     return obj}
    // ) 
    // let exportWorkSheet = XLSX.utils.json_to_sheet(downloadData);
    var mainHeader = configDetails.boardName ? configDetails.boardName : 'Report Data';
    var subHeader = resource.widgetName ? resource.widgetName : 'Sheet 1';
    var heading = [[mainHeader], [""], [subHeader], [" "]].concat(_toConsumableArray(appliedFilters ? customFilters.map(function (cf) {
      return [String(cf.parameterName), String(cf.value)];
    }) : []), _toConsumableArray(appliedDataFilters ? appliedDataFilters.map(function (df) {
      return [String(df.fieldName), String(df.value)];
    }) : []), [[" "]
    // columns.map(c => c.title)
    ]);

    var tableData = document.getElementById('widgetTable' + props.resource.id);
    var workBook = XLSX.utils.book_new();
    var exportWorkSheet = XLSX.utils.aoa_to_sheet([]);
    XLSX.utils.sheet_add_aoa(exportWorkSheet, heading.filter(function (h) {
      return h.length > 0;
    }));
    XLSX.utils.sheet_add_dom(exportWorkSheet, tableData, {
      origin: "A".concat(Number(customFilters.length + appliedDataFilters.length + 5))
    });
    var noOfRowbuilders = resource.aggRowBuilders ? resource.aggRowBuilders.length : 0;
    XLSX.utils.sheet_add_aoa(exportWorkSheet, [["Generated By:", userName, "", "Date", curretTime.format("MM/DD/YYYY"), "", "Time", curretTime.format("HH:mm:ss")]], {
      origin: "A".concat(Number(customFilters.length + appliedDataFilters.length + tableDisplayData.length + noOfRowbuilders + 7))
    });
    // XLSX.utils.sheet_add_aoa([]);
    // XLSX.utils.sheet_add_aoa([]);
    // XLSX.utils.sheet_add_aoa(exportWorkSheet, heading);
    // XLSX.utils.table_to_sheet(exportWorkSheet, tableData, { origin: `A${Number(customFilters.length+appliedDataFilters.length+4)}`});
    // XLSX.utils.sheet_add_json(exportWorkSheet, downloadData, { origin: `A${Number(customFilters.length+appliedDataFilters.length+4)}`, skipHeader: true });

    XLSX.utils.book_append_sheet(workBook, exportWorkSheet, resource.widgetName ? resource.widgetName : 'Sheet1');

    // if (appliedFilters) {
    //     let exportFilterSheet = XLSX.utils.json_to_sheet(customFilters.map(cf => { return { 'Parameter Name': cf.parameterName, 'Value': cf.value } }));
    //     XLSX.utils.book_append_sheet(workBook, exportFilterSheet, resource.widgetName ? `Global Filters` : 'Global Filters');
    // }
    // if (appliedDataFilters && appliedDataFilters.length>0) {
    //     let exportDataFilterSheet = XLSX.utils.json_to_sheet(appliedDataFilters.map(df => { return { 'Parameter Name': df.fieldName, 'Value': df.value } }));
    //     XLSX.utils.book_append_sheet(workBook, exportDataFilterSheet, resource.widgetName ? `Data Filters` : 'Data Filters');
    // }
    var exportFileName = resource.widgetName ? "".concat(resource.widgetName, ".xlsx") : configDetails.boardName ? "".concat(configDetails.boardName, ".xlsx") : 'ReportData.xlsx';
    XLSX.writeFile(workBook, exportFileName);
    setShowActions(false);
  };
  var handlePNGDownload = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var canvas, imgData, link;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return html2canvas(resource.charts && resource.charts.chartType ? document.getElementById('report_data_' + props.resource.id) : document.getElementById('report_data_' + props.resource.id).getElementsByClassName('report-tbl-container')[0], {
              onclone: function onclone(clonedDoc) {
                // I made the div hidden and here I am changing it to visible
                clonedDoc.styleSheets;
                clonedDoc.getElementsByClassName('report-filter-criteria')[0].style.display = 'block';
                clonedDoc.getElementsByClassName('report-filter-criteria')[0].style['padding'] = '36px';
                clonedDoc.getElementsByClassName('widget-table-container')[0].style['padding'] = '36px 0px';
                var trs = clonedDoc.getElementsByClassName('custom-table-th');
                for (var i = 0, len = trs.length; i < len; i++) {
                  trs[i].style["background-color"] = '#245A87';
                  trs[i].style["color"] = '#fff';
                  trs[i].style["font-weight"] = '700';
                  trs[i].style["border"] = 'none';
                }
                clonedDoc.getElementsByClassName('report-footer-data-wrapper')[0].style.display = "block";
              }
            });
          case 2:
            canvas = _context3.sent;
            imgData = canvas.toDataURL('image/png'); // downloadjs(imgData, 'download.png', 'image/png');
            link = document.createElement("a");
            link.download = "download.png";
            link.href = imgData;
            link.click();
            setShowActions(false);
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handlePNGDownload() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handlePDFDownload = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var canvas, imgData, doc, _doc, orgData, startX, startY, finalY;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (_$1.isEmpty(resource.charts)) {
              _context4.next = 10;
              break;
            }
            _context4.next = 3;
            return html2canvas(resource.charts && resource.charts.chartType ? document.getElementById('report_data_' + props.resource.id) : document.getElementById('report_data_' + props.resource.id).getElementsByClassName('report-tbl-container')[0], {
              onclone: function onclone(clonedDoc) {
                // I made the div hidden and here I am changing it to visible
                clonedDoc.getElementsByClassName('report-filter-criteria')[0].style.display = 'block';
                clonedDoc.getElementsByClassName('report-filter-criteria')[0].style['padding'] = '36px';
                // clonedDoc.getElementsByClassName('custom-table-th').style.background === '#245A87';
                // clonedDoc.getElementsByClassName('custom-table-th').forEach(x => {
                //     x.style.background === '#245A87';
                //     x.style.color === '#fff';
                //     x.style.fontWeight = '700'
                // })
              }
            });
          case 3:
            canvas = _context4.sent;
            imgData = canvas.toDataURL('image/png');
            doc = new jsPDF({
              orientation: "landscape",
              unit: "in",
              format: [24, 16]
            });
            doc.addImage(imgData, 'JPEG', 1, 1);
            // pdf.output('dataurlnewwindow');
            doc.save("download.pdf");
            _context4.next = 31;
            break;
          case 10:
            _doc = new jsPDF(); // doc.fromHTML(`<html><head><title>Report Data</title></head><body>` + document.getElementById('filter_criteria_'+props.resource.id).innerHTML + `</body></html>`);
            // var finalY = doc.lastAutoTable.finalY || 10
            // var finalY=10
            // doc.text('From javascript arrays', 14, finalY + 15)
            _doc.addImage(img, 'PNG', 150, 15, 32, 20);
            _doc.setFontSize(16);
            _doc.setTextColor(36, 90, 135);
            _doc.text(props.configDetails.boardName, 15, 25);
            _doc.setFontSize(24);
            _doc.setFont(undefined, 'bold');
            _doc.text(resource.widgetName ? resource.widgetName : resource.connectionData.name, 15, 35);
            _doc.setFontSize(10);
            _doc.setTextColor(40, 40, 40);
            orgData = ['Organization:', organizationName, '  Location :', locationName]; // doc.text( , 15, 45)
            startX = 15;
            startY = 45;
            orgData.forEach(function (text, i) {
              _doc.setFont(undefined, 'normal');
              // every even item is a normal font weight item
              if (i % 2 === 0) {
                _doc.setFont(undefined, 'bold');
              }
              _doc.text(text, startX, startY);
              startX = startX + _doc.getStringUnitWidth(text) + (i % 2 === 0 ? 2 : 4) * 10;
            });

            // const canvas = await html2canvas(document.getElementById('filter_criteria_'+props.resource.id));
            // const imgData = canvas.toDataURL('image/png');
            // doc.addImage(imgData, 'JPEG', 25, 40, 25, 20);

            _doc.autoTable({
              startY: 65,
              html: '#widgetTable' + props.resource.id,
              // didParseCell(data) {
              //     if (data.cell.row.index === 0) {
              //       data.cell.styles.textColor = [255, 255, 255];
              //       data.cell.styles.fillColor = '#';
              //     }
              //   }
              headStyles: {
                fillColor: [36, 90, 135],
                minCellHeight: 12,
                halign: 'center',
                valign: 'middle'
              },
              alternateRowStyles: {
                fillColor: [255, 255, 255],
                lineColor: [255, 0, 0],
                halign: 'center',
                valign: 'middle',
                minCellHeight: 12
              },
              styles: _defineProperty({
                fillColor: [247, 247, 249],
                halign: 'center',
                valign: 'middle',
                minCellHeight: 10
              }, "minCellHeight", 12),
              bodyStyles: {
                lineColor: [255, 0, 0]
              },
              showFoot: 'lastPage',
              tableLineColor: 100
            });
            finalY = _doc.lastAutoTable.finalY + 20;
            _doc.setFontSize(10);
            _doc.setTextColor(40, 40, 40);
            _doc.setFillColor(100, 100, 100, 0.25);
            _doc.text(20, finalY, "GENERATED BY :".concat(userName, "               Date :").concat(curretTime.format("MM/DD/YYYY"), "              Time:").concat(curretTime.format("HH:mm:ss"), " "));
            _doc.save('table.pdf');
          case 31:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function handlePDFDownload() {
      return _ref4.apply(this, arguments);
    };
  }();

  // const handlePDFDownload = async () => {
  //     debugger;
  //     if (!_.isEmpty(resource.charts)) {
  //         const canvas = await html2canvas(resource.charts && resource.charts.chartType ? document.getElementById('report_data_' + props.resource.id) : document.getElementById('report_data_' + props.resource.id).getElementsByClassName('report-tbl-container')[0], {
  //             onclone: function (clonedDoc) {

  //                 // I made the div hidden and here I am changing it to visible
  //                 clonedDoc.getElementsByClassName('report-filter-criteria')[0].style.display = 'block';
  //                 clonedDoc.getElementsByClassName('report-filter-criteria')[0].style['padding'] = '36px';

  //                 // clonedDoc.getElementsByClassName('custom-table-th').style.background === '#245A87';
  //                 // clonedDoc.getElementsByClassName('custom-table-th').forEach(x => {
  //                 //     x.style.background === '#245A87';
  //                 //     x.style.color === '#fff';
  //                 //     x.style.fontWeight = '700'
  //                 // })
  //             }
  //         });
  //         const imgData = canvas.toDataURL('image/png');

  //         const doc = new jsPDF({
  //             orientation: "landscape",
  //             unit: "in",
  //             format: [24, 16]
  //         });

  //         doc.addImage(imgData, 'JPEG', 1, 1);
  //         // pdf.output('dataurlnewwindow');
  //         doc.save("download.pdf");
  //     } else {
  //         const doc = new jsPDF();
  //         // doc.fromHTML(`<html><head><title>Report Data</title></head><body>` + document.getElementById('filter_criteria_'+props.resource.id).innerHTML + `</body></html>`);
  //         var finalY = doc?.lastAutoTable?.finalY || 10
  //         debugger
  //         // const canvas = await html2canvas(document.getElementById('filter_criteria_'+props.resource.id))
  //         // const imgData = canvas.toDataURL('image/png');
  //         // doc.addImage(imgData, 'JPEG', 1, 1);
  //         // doc.text('From javascript arrays', 14, finalY + 15)
  //         doc.addImage(witmegLogo, 'PNG', 150, 15, 32, 20);
  //         doc.setFontSize(16);
  //         doc.setTextColor(36, 90, 135);
  //         doc.text(props.configDetails.boardName,15,25);

  //         doc.setFontSize(24);
  //         doc.setFont(undefined, 'bold')
  //         doc.text(resource.widgetName ? resource.widgetName : resource.connectionData.name ,15,35);

  //         doc.autoTable({ 
  //             startY: 60, 
  //             html: '#widgetTable' + props.resource.id,
  //             // didParseCell(data) {
  //             //     if (data.cell.row.index === 0) {
  //             //       data.cell.styles.textColor = [255, 255, 255];
  //             //       data.cell.styles.fillColor = '#';
  //             //     }
  //             //   }
  //             headStyles :{fillColor : [36, 90, 135], minCellHeight: 12, halign: 'center', valign:'middle'},  
  //             alternateRowStyles: {fillColor : [255, 255, 255], lineColor: [255,0,0], halign: 'center', valign:'middle',minCellHeight: 12 }, 
  //             styles: {fillColor : [247, 247, 249], halign: 'center', valign:'middle', minCellHeight: 10, minCellHeight: 12 }, 
  //             bodyStyles: {lineColor: [255,0,0]},
  //             showFoot: 'lastPage',
  //             tableLineColor: 100
  //         })
  //         doc.save('table.pdf')
  //     }
  // };

  var handleChangeDisplayData = function handleChangeDisplayData(data) {
    console.log("Applied Data Filters====>>", data);
    // setTableDisplayData(data.data)
    setAppliedDataFilters(data.filters);
  };
  if (loadingData) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      type: "title",
      level: 5,
      pattern: "bold",
      alignment: "left",
      className: "report-name-header-section"
    }, resource.widgetName ? resource.widgetName : resource.connectionData.name), /*#__PURE__*/React.createElement("div", {
      className: "report-container-body"
    }, /*#__PURE__*/React.createElement(Spin, null)));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: isFullScreenOpen ? 'full-screen-widget' : ''
  }, /*#__PURE__*/React.createElement(FullScreen, {
    handle: screen,
    onChange: reportChange
  }, /*#__PURE__*/React.createElement("div", {
    className: "report-name-header-section"
  }, /*#__PURE__*/React.createElement(Typography, {
    type: "title",
    level: 5,
    pattern: "bold",
    alignment: "left"
  }, resource.widgetName ? resource.widgetName : resource.connectionData.name), /*#__PURE__*/React.createElement(PopoverWithContent, {
    overlayClassName: "download-overlay",
    open: showActions,
    onOpenChange: toggleActions,
    popoverContent: /*#__PURE__*/React.createElement(Stack, {
      direction: "column",
      verticalAlign: "v_start"
    }, /*#__PURE__*/React.createElement(Typography, {
      type: "text",
      color: "gray_base",
      alignment: "left"
    }, "Download"), /*#__PURE__*/React.createElement(ActionList, {
      width: 160,
      items: [{
        key: 4,
        prefix: /*#__PURE__*/React.createElement(Icon, {
          name: "file-xls",
          size: 16
        }),
        content: 'xls file',
        onClick: function onClick() {
          downloadReportData();
        }
      }, {
        key: 5,
        prefix: /*#__PURE__*/React.createElement(Icon, {
          name: "file-pdf",
          size: 16
        }),
        content: 'PDF file',
        onClick: function onClick() {
          handlePDFDownload();
        }
      }, {
        key: 6,
        prefix: /*#__PURE__*/React.createElement(Icon, {
          name: "file-image",
          size: 16
        }),
        content: 'PNG file',
        onClick: function onClick() {
          handlePNGDownload();
        }
      }],
      type: "action"
    }))
  }, /*#__PURE__*/React.createElement(Stack, {
    verticalAlign: "v_center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "eco-mr-16"
  }, properties.autorefresh ? /*#__PURE__*/React.createElement(Icon, {
    name: "update",
    size: 24,
    color: "blue",
    type: "filled"
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "update",
    size: 24
  })), properties.autorefresh ? /*#__PURE__*/React.createElement("div", {
    className: "eco-mr-16",
    onClick: isFullScreenOpen ? screen.exit : screen.enter,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: isFullScreenOpen ? 'exit-full-screen' : 'full-screen',
    size: 24
  })) : null, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      return handleShowActions(e);
    },
    className: "eco-mr-16"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "download",
    size: 24
  })), /*#__PURE__*/React.createElement(PopoverWithContent, {
    overlayClassName: "instructions-overlay",
    popoverTitle: "",
    popoverContent: /*#__PURE__*/React.createElement(Stack, {
      direction: "column",
      verticalAlign: "v_start"
    }, /*#__PURE__*/React.createElement(Typography, {
      type: "text",
      color: "gray_base",
      className: "eco-mb-16"
    }, "Instructions"), _toConsumableArray(customFilters).filter(function (cf) {
      return cf.config;
    }).map(function (cfv, k) {
      var _cfv$config, _cfv$config2;
      return /*#__PURE__*/React.createElement(Typography, {
        type: "title",
        level: 5,
        className: "eco-mb-24",
        pattern: "bold"
      }, k + 1, ". \xA0", cfv.parameterName, " is limited", cfv.dataType === "date" ? cfv.config.range === 'dynamic' ? " to ".concat(cfv.config.value) : "After 2000-01-01" : cfv.dataType === "number" ? " Between ".concat((cfv === null || cfv === void 0 ? void 0 : (_cfv$config = cfv.config) === null || _cfv$config === void 0 ? void 0 : _cfv$config.min) || 0, " to ").concat((cfv === null || cfv === void 0 ? void 0 : (_cfv$config2 = cfv.config) === null || _cfv$config2 === void 0 ? void 0 : _cfv$config2.min) || 100000) : ' to length of 100 Charactors');
    })),
    open: showInstructionsMenu,
    onOpenChange: function onOpenChange() {
      return setShowInstructionsMenu(!showInstructionsMenu);
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: "eco-mr-16"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "important",
    size: 24
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "report-container-body"
  }, resource.customFilters.length > 0 ? /*#__PURE__*/React.createElement(FiltersWidget, {
    filters: customFilters,
    id: resource.resourceId,
    handleApplyGlobalFilters: handleApplyGlobalFilters,
    handleResetGlobalFilters: handleResetGlobalFilters,
    widgetWidth: widgetWidth,
    reportName: props.configDetails.boardName,
    appliedFilters: appliedFilters,
    globalFilters: customFilters
  }) : null, /*#__PURE__*/React.createElement("div", null), resource.charts && resource.charts.chartType ? /*#__PURE__*/React.createElement(ChartWidget, {
    reportData: dataSource,
    resource: resource,
    reportName: props.configDetails.boardName,
    appliedFilters: appliedFilters,
    globalFilters: customFilters,
    isFullScreenOpen: isFullScreenOpen
  }) : /*#__PURE__*/React.createElement(TableWidget, {
    tableData: dataSource,
    tableColumns: columns,
    resource: resource,
    reportName: props.configDetails.boardName,
    appliedFilters: appliedFilters,
    globalFilters: customFilters,
    handleChangeDisplayData: handleChangeDisplayData,
    appliedDataFilters: appliedDataFilters,
    organizationName: organizationName,
    locationName: locationName,
    userName: userName,
    curretTime: curretTime
  }))));
};

// const ReactGridLayout = WidthProvider(RGL);

var ReportWidgets = function ReportWidgets(props) {
  var resources = props.resources,
    configDetails = props.configDetails,
    properties = props.properties,
    token = props.token,
    userName = props.userName,
    organizationName = props.organizationName,
    locationName = props.locationName;
  var _useState = useState(window.innerWidth),
    _useState2 = _slicedToArray(_useState, 2),
    windowWidth = _useState2[0],
    setWindowWidth = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    layout = _useState4[0],
    setLayout = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFullScreenOpen = _useState6[0],
    setIsFullScreenOpen = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    _useState8[1];
  var screen = useFullScreenHandle();
  var reportChange = useCallback(function (state, handle) {
    // if (handle === screen) {
    setIsFullScreenOpen(state);
    console.log('Screen 1 went to', state, handle);
    // }
  }, [screen]);
  useEffect(function () {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowWidth(isFullScreenOpen ? window.innerWidth : window.innerWidth - 280);
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [isFullScreenOpen]); // Empty array ensures that effect is only run on mounteEffect

  useEffect(function () {
    if (resources.length === 1) {
      setLayout([{
        h: 8,
        i: "0",
        w: 12,
        x: 0,
        y: 0
      }]);
    } else {
      setLayout(resources.map(function (r) {
        return r.layout;
      }));
    }
    // } else {
    //   setLayout([{ i: "0", x: 0, y: 0, w: 12, h: 8}])
    // }
  }, [resources]);

  // useEffect(() => {
  //   if(properties.autorefresh) {
  //     let timeout=properties.refreshInterval || '30s';

  //   }
  // }, [properties])

  return /*#__PURE__*/React.createElement("div", {
    className: "report-container"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FullScreen, {
    handle: screen,
    onChange: reportChange
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-header-bar"
  }, /*#__PURE__*/React.createElement(Stack, {
    horizontalAlign: "space_between"
  }, /*#__PURE__*/React.createElement(Typography, {
    pattern: "bold",
    type: "title",
    level: 4
  }, configDetails === null || configDetails === void 0 ? void 0 : configDetails.boardName), /*#__PURE__*/React.createElement("div", null, properties.autorefresh ? /*#__PURE__*/React.createElement(Icon, {
    name: "update",
    color: "blue",
    type: "filled"
  })
  // <>    
  //   <PopoverWithContent
  //               // overlayClassName=""
  //               popoverTitle=""
  //               popoverContent={
  //                 <div>
  //                   <Typography>Refresh Interval</Typography>
  //                   <br />
  //                   <Typography>Never</Typography>
  //                   <Typography>30 Second</Typography>
  //                 </div>
  //               }
  //               open={showAutoRefreshOptions}
  //               onOpenChange={()=> setShowAutoRefreshOptions(!showAutoRefreshOptions)}
  //               >
  //               <Button category="icon" children="update" size="size" variant="subtle"/>
  //           </PopoverWithContent>
  // </>
  : /*#__PURE__*/React.createElement(Icon, {
    name: "update"
  }), properties.fullscreen ? /*#__PURE__*/React.createElement(Button, {
    className: "full-screen-btn",
    category: "icon",
    children: isFullScreenOpen ? 'exit-full-screen' : 'full-screen',
    size: "size",
    onClick: isFullScreenOpen ? screen.exit : screen.enter,
    variant: "subtle"
  }) : null))), /*#__PURE__*/React.createElement("div", {
    id: "full-report"
  }, layout.length > 0 ? /*#__PURE__*/React.createElement(GridLayout, {
    className: "layout"
    // layout={layout}
    ,
    cols: 12,
    rowHeight: 64,
    width: windowWidth,
    isDraggable: false,
    autoSize: true,
    allowOverlap: false,
    style: {
      maxHeight: '240vh !important'
    },
    compactType: "horizontal",
    preventCollision: true,
    measureBeforeMount: false,
    isDroppable: true,
    margin: [0, 0],
    isResizable: true
    // {...props}
  }, resources.map(function (r, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "res_".concat(i),
      "data-grid": layout[i]
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        padding: '10px'
      }
    }, /*#__PURE__*/React.createElement(ReportContainer, {
      configDetails: props.configDetails,
      resource: r,
      widgetWidth: layout.length !== 1 ? layout[i].w * windowWidth / 12 : windowWidth,
      userId: props.userId,
      organizationId: props.organizationId,
      cloudLocationId: props.cloudLocationId,
      properties: properties,
      token: token,
      userName: userName,
      organizationName: organizationName,
      locationName: locationName
    })));
  })) : null))));
};

var Dashboard = function Dashboard(_ref) {
  var baseUrl = _ref.baseUrl,
    token = _ref.token,
    dashboardId = _ref.dashboardId,
    userId = _ref.userId,
    organizationId = _ref.organizationId,
    cloudLocationId = _ref.cloudLocationId,
    userName = _ref.userName,
    organizationName = _ref.organizationName,
    locationName = _ref.locationName;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    boardInfo = _useState2[0],
    setBoardInfo = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedResources = _useState4[0],
    setSelectedResources = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loadingData = _useState6[0],
    setLoadingData = _useState6[1];
  useEffect(function () {
    var getReportDetails = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response, data, selectedResourcesList;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(baseUrl && token && dashboardId)) {
                _context.next = 15;
                break;
              }
              // dispatchUseReducer({
              //   type: 'setBoardStatus',
              //   payload: 'pending'
              // })
              setLoadingData(true);
              _context.next = 4;
              return fetch("".concat(baseUrl, "/").concat(dashboardId), {
                headers: {
                  Authorization: "Bearer ".concat(token)
                }
              });
            case 4:
              response = _context.sent;
              _context.next = 7;
              return response.json();
            case 7:
              data = _context.sent;
              setBoardInfo(data.data);
              _context.next = 11;
              return Promise.all(data.data && data.data.resources.map(function (r) {
                return r;
              }));
            case 11:
              selectedResourcesList = _context.sent;
              setSelectedResources(selectedResourcesList);
              setLoadingData(false);
              if (Boolean(data === null || data === void 0 ? void 0 : data.data.resources.length)) {
                console.log("selectedResources ===>>", selectedResourcesList);
                // setBoardInfo(Object.assign({}, data.data, { resources: selectedResources }))
                // setBoardInfo({ board: Object.assign({}, boardInfo, data.data, { resources: selectedResources }) })
                // dispatchUseReducer({
                //   type: 'setSelectedBoard',
                //   payload: Object.assign({}, data.data, { resources: selectedResources })
                // });
                // dispatchUseReducer({
                //   type: 'setBoardStatus',
                //   payload: 'complete'
                // })
              }
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getReportDetails() {
        return _ref2.apply(this, arguments);
      };
    }();
    getReportDetails();
  }, [baseUrl, token, dashboardId, organizationId, cloudLocationId]);
  return /*#__PURE__*/React.createElement("div", null, loadingData ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement("div", null, selectedResources && selectedResources.length > 0 ? /*#__PURE__*/React.createElement(ReportWidgets, {
    configDetails: boardInfo.configDetails,
    resources: selectedResources,
    properties: boardInfo.properties,
    userId: userId,
    organizationId: organizationId,
    cloudLocationId: cloudLocationId,
    token: token,
    userName: userName,
    organizationName: organizationName,
    locationName: locationName
  }) : /*#__PURE__*/React.createElement("div", null, "Loading ... ")));
};

export { Dashboard };
